window.theme = window.theme || {};
window.theme = window.theme || {};
theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
    $(document)
        .on("shopify:section:load", this._onSectionLoad.bind(this))
        .on("shopify:section:unload", this._onSectionUnload.bind(this))
        .on("shopify:section:select", this._onSelect.bind(this))
        .on("shopify:section:deselect", this._onDeselect.bind(this))
        .on("shopify:block:select", this._onBlockSelect.bind(this))
        .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
};
theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
    _createInstance: function (container, constructor) {
        var $container = $(container);
        var id = $container.attr("data-section-id");
        var type = $container.attr("data-section-type");
        constructor = constructor || this.constructors[type];
        if (_.isUndefined(constructor)) {
            return;
        }
        var instance = _.assignIn(new constructor(container), { id: id, type: type, container: container });
        this.instances.push(instance);
    },
    _onSectionLoad: function (evt) {
        var container = $("[data-section-id]", evt.target)[0];
        if (container) {
            this._createInstance(container);
        }
    },
    _onSectionUnload: function (evt) {
        this.instances = _.filter(this.instances, function (instance) {
            var isEventInstance = instance.id === evt.detail.sectionId;
            if (isEventInstance) {
                if (_.isFunction(instance.onUnload)) {
                    instance.onUnload(evt);
                }
            }
            return !isEventInstance;
        });
    },
    _onSelect: function (evt) {
        var instance = _.find(this.instances, function (instance) {
            return instance.id === evt.detail.sectionId;
        });
        if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
            instance.onSelect(evt);
        }
    },
    _onDeselect: function (evt) {
        var instance = _.find(this.instances, function (instance) {
            return instance.id === evt.detail.sectionId;
        });
        if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
            instance.onDeselect(evt);
        }
    },
    _onBlockSelect: function (evt) {
        var instance = _.find(this.instances, function (instance) {
            return instance.id === evt.detail.sectionId;
        });
        if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
            instance.onBlockSelect(evt);
        }
    },
    _onBlockDeselect: function (evt) {
        var instance = _.find(this.instances, function (instance) {
            return instance.id === evt.detail.sectionId;
        });
        if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
            instance.onBlockDeselect(evt);
        }
    },
    register: function (type, constructor) {
        this.constructors[type] = constructor;
        $("[data-section-type=" + type + "]").each(
            function (index, container) {
                this._createInstance(container, constructor);
            }.bind(this)
        );
    },
});
window.slate = window.slate || {};
slate.rte = {
    wrapTable: function () {
        $(".rte table").wrap('<div class="rte__table-wrapper"></div>');
    },
    iframeReset: function () {
        var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
        var $iframeReset = $iframeVideo.add(".rte iframe#admin_bar_iframe");
        $iframeVideo.each(function () {
            $(this).wrap('<div class="video-wrapper"></div>');
        });
        $iframeReset.each(function () {
            this.src = this.src;
        });
    },
};
window.slate = window.slate || {};
slate.a11y = {
    pageLinkFocus: function ($element) {
        var focusClass = "js-focus-hidden";
        $element.first().attr("tabIndex", "-1").focus().addClass(focusClass).one("blur", callback);
        function callback() {
            $element.first().removeClass(focusClass).removeAttr("tabindex");
        }
    },
    focusHash: function () {
        var hash = window.location.hash;
        if (hash && document.getElementById(hash.slice(1))) {
            this.pageLinkFocus($(hash));
        }
    },
    bindInPageLinks: function () {
        $("a[href*=#]").on(
            "click",
            function (evt) {
                this.pageLinkFocus($(evt.currentTarget.hash));
            }.bind(this)
        );
    },
    trapFocus: function (options) {
        var eventName = options.namespace ? "focusin." + options.namespace : "focusin";
        if (!options.$elementToFocus) {
            options.$elementToFocus = options.$container;
        }
        options.$container.attr("tabindex", "-1");
        options.$elementToFocus.focus();
        $(document).off("focusin");
        $(document).on(eventName, function (evt) {
            if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
                options.$container.focus();
            }
        });
    },
    removeTrapFocus: function (options) {
        var eventName = options.namespace ? "focusin." + options.namespace : "focusin";
        if (options.$container && options.$container.length) {
            options.$container.removeAttr("tabindex");
        }
        $(document).off(eventName);
    },
};
theme.Images = (function () {
    function preload(images, size) {
        if (typeof images === "string") {
            images = [images];
        }
        for (var i = 0; i < images.length; i++) {
            var image = images[i];
            this.loadImage(this.getSizedImageUrl(image, size));
        }
    }
    function loadImage(path) {
        new Image().src = path;
    }
    function switchImage(image, element, callback) {
        var size = this.imageSize(element.src);
        var imageUrl = this.getSizedImageUrl(image.src, size);
        if (callback) {
            callback(imageUrl, image, element);
        } else {
            element.src = imageUrl;
        }
    }
    function imageSize(src) {
        var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
        if (match !== null) {
            return match[1];
        } else {
            return null;
        }
    }
    function getSizedImageUrl(src, size) {
        if (size == null) {
            return src;
        }
        if (size === "master") {
            return this.removeProtocol(src);
        }
        var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (match != null) {
            var prefix = src.split(match[0]);
            var suffix = match[0];
            return this.removeProtocol(prefix[0] + "_" + size + suffix);
        }
        return null;
    }
    function removeProtocol(path) {
        return path.replace(/http(s)?:/, "");
    }
    return { preload: preload, loadImage: loadImage, switchImage: switchImage, imageSize: imageSize, getSizedImageUrl: getSizedImageUrl, removeProtocol: removeProtocol };
})();
theme.Currency = (function () {
    var moneyFormat = "${{amount}}";
    function formatMoney(cents, format) {
        if (typeof cents === "string") {
            cents = cents.replace(".", "");
        }
        var value = "";
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = format || moneyFormat;
        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = precision || 2;
            thousands = thousands || ",";
            decimal = decimal || ".";
            if (isNaN(number) || number == null) {
                return 0;
            }
            number = (number / 100.0).toFixed(precision);
            var parts = number.split(".");
            var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
            var centsAmount = parts[1] ? decimal + parts[1] : "";
            return dollarsAmount + centsAmount;
        }
        switch (formatString.match(placeholderRegex)[1]) {
            case "amount":
                value = formatWithDelimiters(cents, 2);
                break;
            case "amount_no_decimals":
                value = formatWithDelimiters(cents, 0);
                break;
            case "amount_with_comma_separator":
                value = formatWithDelimiters(cents, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                value = formatWithDelimiters(cents, 0, ".", ",");
                break;
            case "amount_no_decimals_with_space_separator":
                value = formatWithDelimiters(cents, 0, " ");
                break;
        }
        return formatString.replace(placeholderRegex, value);
    }
    return { formatMoney: formatMoney };
})();
slate.Variants = (function () {
    function Variants(options) {
        this.$container = options.$container;
        this.product = options.product;
        this.singleOptionSelector = options.singleOptionSelector;
        this.originalSelectorId = options.originalSelectorId;
        this.enableHistoryState = options.enableHistoryState;
        this.currentVariant = this._getVariantFromOptions();
        $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this));
    }
    Variants.prototype = _.assignIn({}, Variants.prototype, {
        _getCurrentOptions: function () {
            var currentOptions = _.map($(this.singleOptionSelector, this.$container), function (element) {
                var $element = $(element);
                var type = $element.attr("type");
                var currentOption = {};
                if (type === "radio" || type === "checkbox") {
                    if ($element[0].checked) {
                        currentOption.value = $element.val();
                        currentOption.index = $element.data("index");
                        return currentOption;
                    } else {
                        return false;
                    }
                } else {
                    currentOption.value = $element.val();
                    currentOption.index = $element.data("index");
                    return currentOption;
                }
            });
            currentOptions = _.compact(currentOptions);
            return currentOptions;
        },
        _getVariantFromOptions: function () {
            var selectedValues = this._getCurrentOptions();
            var variants = this.product.variants;
            var found = _.find(variants, function (variant) {
                return selectedValues.every(function (values) {
                    return _.isEqual(variant[values.index], values.value);
                });
            });
            return found;
        },
        _onSelectChange: function () {
            var variant = this._getVariantFromOptions();
            this.$container.trigger({ type: "variantChange", variant: variant });
            if (!variant) {
                return;
            }
            this._updateMasterSelect(variant);
            this._updateImages(variant);
            this._updatePrice(variant);
            this._updateSKU(variant);
            this.currentVariant = variant;
            if (this.enableHistoryState) {
                this._updateHistoryState(variant);
            }
        },
        _updateImages: function (variant) {
            var variantImage = variant.featured_image || {};
            var currentVariantImage = this.currentVariant.featured_image || {};
            if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
                return;
            }
            this.$container.trigger({ type: "variantImageChange", variant: variant });
        },
        _updatePrice: function (variant) {
            if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
                return;
            }
            this.$container.trigger({ type: "variantPriceChange", variant: variant });
        },
        _updateSKU: function (variant) {
            if (variant.sku === this.currentVariant.sku) {
                return;
            }
            this.$container.trigger({ type: "variantSKUChange", variant: variant });
        },
        _updateHistoryState: function (variant) {
            if (!history.replaceState || !variant) {
                return;
            }
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + variant.id;
            window.history.replaceState({ path: newurl }, "", newurl);
        },
        _updateMasterSelect: function (variant) {
            $(this.originalSelectorId, this.$container).val(variant.id);
        },
    });
    return Variants;
})();
theme.Drawers = (function () {
    function Drawer(id, position, options) {
        var defaults = { close: ".js-drawer-close", open: ".js-drawer-open-" + position, openClass: "js-drawer-open", dirOpenClass: "js-drawer-open-" + position };
        this.nodes = { $parent: $("html").add("body"), $page: $("#PageContainer") };
        this.config = $.extend(defaults, options);
        this.position = position;
        this.$drawer = $("#" + id);
        if (!this.$drawer.length) {
            return false;
        }
        this.drawerIsOpen = false;
        this.init();
    }
    Drawer.prototype.init = function () {
        $(this.config.open).on("click", $.proxy(this.open, this));
        this.$drawer.on("click", this.config.close, $.proxy(this.close, this));
    };
    Drawer.prototype.open = function (evt) {
        var externalCall = false;
        if (evt) {
            evt.preventDefault();
        } else {
            externalCall = true;
        }
        if (evt && evt.stopPropagation) {
            evt.stopPropagation();
            this.$activeSource = $(evt.currentTarget);
        }
        if (this.drawerIsOpen && !externalCall) {
            return this.close();
        }
        this.$drawer.prepareTransition();
        this.nodes.$parent.addClass(this.config.openClass + " " + this.config.dirOpenClass);
        this.drawerIsOpen = true;
        slate.a11y.trapFocus({ $container: this.$drawer, namespace: "drawer_focus" });
        if (this.config.onDrawerOpen && typeof this.config.onDrawerOpen === "function") {
            if (!externalCall) {
                this.config.onDrawerOpen();
            }
        }
        if (this.$activeSource && this.$activeSource.attr("aria-expanded")) {
            this.$activeSource.attr("aria-expanded", "true");
        }
        this.bindEvents();
        return this;
    };
    Drawer.prototype.close = function () {
        if (!this.drawerIsOpen) {
            return;
        }
        $(document.activeElement).trigger("blur");
        this.$drawer.prepareTransition();
        this.nodes.$parent.removeClass(this.config.dirOpenClass + " " + this.config.openClass);
        this.drawerIsOpen = false;
        slate.a11y.removeTrapFocus({ $container: this.$drawer, namespace: "drawer_focus" });
        this.unbindEvents();
    };
    Drawer.prototype.bindEvents = function () {
        this.nodes.$parent.on(
            "keyup.drawer",
            $.proxy(function (evt) {
                if (evt.keyCode === 27) {
                    this.close();
                    return false;
                } else {
                    return true;
                }
            }, this)
        );
        this.nodes.$page.on("touchmove.drawer", function () {
            return false;
        });
        this.nodes.$page.on(
            "click.drawer",
            $.proxy(function () {
                this.close();
                return false;
            }, this)
        );
    };
    Drawer.prototype.unbindEvents = function () {
        this.nodes.$page.off(".drawer");
        this.nodes.$parent.off(".drawer");
    };
    return Drawer;
})();
window.theme = window.theme || {};
theme.Header = (function () {
    var selectors = {
        body: "body",
        navigation: "#AccessibleNav",
        siteNavHasDropdown: ".site-nav--has-dropdown",
        siteNavChildLinks: ".site-nav__child-link",
        siteNavActiveDropdown: ".site-nav--active-dropdown",
        siteNavLinkMain: ".site-nav__link--main",
        siteNavChildLink: ".site-nav__link--last",
    };
    var config = { activeClass: "site-nav--active-dropdown", childLinkClass: "site-nav__child-link" };
    var cache = {};
    function init() {
        cacheSelectors();
        cache.$parents.on("click.siteNav", function (evt) {
            var $el = $(this);
            if (!$el.hasClass(config.activeClass)) {
                evt.preventDefault();
                evt.stopImmediatePropagation();
            }
            showDropdown($el);
        });
        $(selectors.siteNavChildLink).on("focusout.siteNav", function () {
            setTimeout(function () {
                if ($(document.activeElement).hasClass(config.childLinkClass) || !cache.$activeDropdown.length) {
                    return;
                }
                hideDropdown(cache.$activeDropdown);
            });
        });
        cache.$topLevel.on("focus.siteNav", function () {
            if (cache.$activeDropdown.length) {
                hideDropdown(cache.$activeDropdown);
            }
        });
        cache.$subMenuLinks.on("click.siteNav", function (evt) {
            evt.stopImmediatePropagation();
        });
    }
    function cacheSelectors() {
        cache = {
            $nav: $(selectors.navigation),
            $topLevel: $(selectors.siteNavLinkMain),
            $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
            $subMenuLinks: $(selectors.siteNavChildLinks),
            $activeDropdown: $(selectors.siteNavActiveDropdown),
        };
    }
    function showDropdown($el) {
        $el.addClass(config.activeClass);
        if (cache.$activeDropdown.length) {
            hideDropdown(cache.$activeDropdown);
        }
        cache.$activeDropdown = $el;
        $el.find(selectors.siteNavLinkMain).attr("aria-expanded", "true");
        setTimeout(function () {
            $(window).on("keyup.siteNav", function (evt) {
                if (evt.keyCode === 27) {
                    hideDropdown($el);
                }
            });
            $(selectors.body).on("click.siteNav", function () {
                hideDropdown($el);
            });
        }, 250);
    }
    function hideDropdown($el) {
        $el.find(selectors.siteNavLinkMain).attr("aria-expanded", "false");
        $el.removeClass(config.activeClass);
        cache.$activeDropdown = $(selectors.siteNavActiveDropdown);
        $(selectors.body).off("click.siteNav");
        $(window).off("keyup.siteNav");
    }
    function unload() {
        $(window).off(".siteNav");
        cache.$parents.off(".siteNav");
        cache.$subMenuLinks.off(".siteNav");
        cache.$topLevel.off(".siteNav");
        $(selectors.siteNavChildLink).off(".siteNav");
        $(selectors.body).off(".siteNav");
    }
    return { init: init, unload: unload };
})();
window.theme = window.theme || {};
theme.MobileNav = (function () {
    var classes = {
        mobileNavOpenIcon: "mobile-nav--open",
        mobileNavCloseIcon: "mobile-nav--close",
        subNavLink: "mobile-nav__sublist-link",
        return: "mobile-nav__return-btn",
        subNavActive: "is-active",
        subNavClosing: "is-closing",
        navOpen: "js-menu--is-open",
        subNavShowing: "sub-nav--is-open",
        thirdNavShowing: "third-nav--is-open",
        subNavToggleBtn: "js-toggle-submenu",
    };
    var cache = {};
    var isTransitioning;
    var $activeSubNav;
    var $activeTrigger;
    var menuLevel = 1;
    var mediaQuerySmall = "screen and (max-width: 992px)";
    function init() {
        cacheSelectors();
        cache.$mobileNavToggle.on("click", toggleMobileNav);
        cache.$subNavToggleBtn.on("click.subNav", toggleSubNav);
        enquire.register(mediaQuerySmall, {
            unmatch: function () {
                closeMobileNav();
            },
        });
    }
    function toggleMobileNav() {
        if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
            closeMobileNav();
        } else {
            openMobileNav();
        }
    }
    function cacheSelectors() {
        cache = {
            $pageContainer: $("#PageContainer"),
            $siteAnnouncementBar: $(".notification-bar"),
            $mobileNavToggle: $(".js-mobile-nav-toggle"),
            $mobileNavContainer: $(".mobile-nav-wrapper"),
            $mobileNav: $("#MobileNav"),
            $subNavToggleBtn: $("." + classes.subNavToggleBtn),
        };
    }
    function openMobileNav() {

        var translateHeaderHeight = 0;

        /*
        if (cache.$siteAnnouncementBar.length > 0) {
            translateHeaderHeight = cache.$siteAnnouncementBar.outerHeight() + cache.$siteAnnouncementBar.offset().top;
        }
        */

        cache.$mobileNavContainer.prepareTransition().addClass(classes.navOpen);
        cache.$mobileNavContainer.css({ transform: "translate3d(100%, 0, 0)", top: `${translateHeaderHeight}px`});
        // cache.$pageContainer.css({ transform: "translate3d(0, " + cache.$mobileNavContainer[0].scrollHeight + "px, 0)" });
        slate.a11y.trapFocus({ $container: cache.$mobileNav, namespace: "navFocus" });
        cache.$mobileNavToggle.addClass(classes.mobileNavCloseIcon).removeClass(classes.mobileNavOpenIcon);
        $('body').addClass('mobile-nav--visible');
        $(window).on("keyup.mobileNav", function (evt) {
            if (evt.which === 27) {
                closeMobileNav();
            }
        });
    }
    function closeMobileNav() {
        $('body').removeClass('mobile-nav--visible');
        cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);
        cache.$mobileNavContainer.css({ transform: "translate3d(-100%, 0, 0)" });
        cache.$pageContainer.removeAttr("style");
        cache.$mobileNavContainer.one("TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle", function () {
            slate.a11y.removeTrapFocus({ $container: cache.$mobileNav, namespace: "navFocus" });
        });
        cache.$mobileNavToggle.addClass(classes.mobileNavOpenIcon).removeClass(classes.mobileNavCloseIcon);
        $(window).off("keyup.mobileNav");

        $('body').find('.mobile-submenu__list').removeClass('active');
    }
    function toggleSubNav(evt) {
        // if (isTransitioning) {
        //     return;
        // }
        // var $toggleBtn = $(evt.currentTarget);
        // var isReturn = $toggleBtn.hasClass(classes.return);
        // isTransitioning = true;
        // if (isReturn) {
        //     $("." + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]').removeClass(classes.subNavActive);
        //     if ($activeTrigger && $activeTrigger.length) {
        //         $activeTrigger.removeClass(classes.subNavActive);
        //     }
        // } else {
        //     $toggleBtn.addClass(classes.subNavActive);
        // }
        // $activeTrigger = $toggleBtn;
        // goToSubnav($toggleBtn.data("target"));
    }
    function goToSubnav(target) {
        // var $targetMenu = target ? $('.mobile-nav__dropdown[data-parent="' + target + '"]') : cache.$mobileNav;
        // menuLevel = $targetMenu.data("level") ? $targetMenu.data("level") : 1;
        // if ($activeSubNav && $activeSubNav.length) {
        //     $activeSubNav.prepareTransition().addClass(classes.subNavClosing);
        // }
        // $activeSubNav = $targetMenu;
        // var $elementToFocus = target ? $targetMenu.find("." + classes.subNavLink + ":first") : $activeTrigger;
        // var translateMenuHeight = $targetMenu[0].scrollHeight;
        // if (!target) {
        //     translateMenuHeight = $targetMenu.outerHeight();
        // }
        // var openNavClass = menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;
        // cache.$mobileNavContainer.css("height", translateMenuHeight).removeClass(classes.thirdNavShowing).addClass(openNavClass);
        // if (!target) {
        //     cache.$mobileNavContainer.removeClass(classes.thirdNavShowing).removeClass(classes.subNavShowing);
        // }
        // cache.$mobileNavContainer.one("TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle", function () {
        //     slate.a11y.trapFocus({ $container: $targetMenu, $elementToFocus: $elementToFocus, namespace: "subNavFocus" });
        //     cache.$mobileNavContainer.off(".subnavToggle");
        //     isTransitioning = false;
        // });
        // cache.$pageContainer.css({ transform: "translate3d(0, " + translateMenuHeight + "px, 0)" });
        // $activeSubNav.removeClass(classes.subNavClosing);
    }
    return { init: init, closeMobileNav: closeMobileNav };
})(jQuery);
window.theme = window.theme || {};
theme.Search = (function () {
    var selectors = {
        search: ".search",
        searchSubmit: ".search__submit",
        searchInput: ".search__input",
        siteHeader: ".site-header",
        siteHeaderSearchToggle: ".site-header__search-toggle",
        siteHeaderSearch: ".site-header__search",
        searchDrawer: ".search-bar",
        searchDrawerInput: ".search-bar__input",
        searchHeader: ".search-header",
        searchHeaderInput: ".search-header__input",
        searchHeaderSubmit: ".search-header__submit",
        mobileNavWrapper: ".mobile-nav-wrapper",
    };
    var classes = { focus: "search--focus", mobileNavIsOpen: "js-menu--is-open" };
    function init() {
        if (!$(selectors.siteHeader).length) {
            return;
        }
        initDrawer();
        searchSubmit();
        $(selectors.searchHeaderInput)
            .add(selectors.searchHeaderSubmit)
            .on("focus blur", function () {
                $(selectors.searchHeader).toggleClass(classes.focus);
            });
        $(selectors.siteHeaderSearchToggle).on("click", function () {
            var searchHeight = $(selectors.siteHeader).outerHeight();
            var searchOffset = $(selectors.siteHeader).offset().top - searchHeight;
            // $(selectors.searchDrawer).css({ height: searchHeight + "px", top: searchOffset + "px" });
        });
    }
    function initDrawer() {
        $("#PageContainer").addClass("drawer-page-content");
        $(".js-drawer-open-top").attr("aria-controls", "SearchDrawer").attr("aria-expanded", "false");
        theme.SearchDrawer = new theme.Drawers("SearchDrawer", "top", { onDrawerOpen: searchDrawerFocus });
    }
    function searchDrawerFocus() {
        searchFocus($(selectors.searchDrawerInput));
        if ($(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen)) {
            theme.MobileNav.closeMobileNav();
        }
    }
    function searchFocus($el) {
        $el.focus();
        $el[0].setSelectionRange(0, $el[0].value.length);
    }
    function searchSubmit() {
        $(selectors.searchSubmit).on("click", function (evt) {
            var $el = $(evt.target);
            var $input = $el.parents(selectors.search).find(selectors.searchInput);
            if ($input.val().length === 0) {
                evt.preventDefault();
                searchFocus($input);
            }
        });
    }
    return { init: init };
})();
(function () {
    var selectors = { backButton: ".return-link" };
    var $backButton = $(selectors.backButton);
    if (!document.referrer || !$backButton.length || !window.history.length) {
        return;
    }
    $backButton.one("click", function (evt) {
        evt.preventDefault();
        var referrerDomain = urlDomain(document.referrer);
        var shopDomain = urlDomain(window.location.href);
        if (shopDomain === referrerDomain) {
            history.back();
        }
        return false;
    });
    function urlDomain(url) {
        var anchor = document.createElement("a");
        anchor.ref = url;
        return anchor.hostname;
    }
})();
theme.Slideshow = (function () {
    this.$slideshow = null;
    var classes = {
        wrapper: "slideshow-wrapper",
        slideshow: "slideshow",
        currentSlide: "slick-current",
        video: "slideshow__video",
        videoBackground: "slideshow__video--background",
        closeVideoBtn: "slideshow__video-control--close",
        pauseButton: "slideshow__pause",
        isPaused: "is-paused",
    };
    function slideshow(el) {
        this.$slideshow = $(el);
        this.$wrapper = this.$slideshow.closest("." + classes.wrapper);
        this.$pause = this.$wrapper.find("." + classes.pauseButton);
        this.settings = { accessibility: true, arrows: false, dots: true, fade: true, draggable: true, touchThreshold: 20, autoplay: this.$slideshow.data("autoplay"), autoplaySpeed: this.$slideshow.data("speed") };
        this.$slideshow.on("beforeChange", beforeChange.bind(this));
        this.$slideshow.on("init", slideshowA11y.bind(this));
        this.$slideshow.slick(this.settings);
        this.$pause.on("click", this.togglePause.bind(this));
    }
    function slideshowA11y(event, obj) {
        var $slider = obj.$slider;
        var $list = obj.$list;
        var $wrapper = this.$wrapper;
        var autoplay = this.settings.autoplay;
        $list.removeAttr("aria-live");
        $wrapper.on("focusin", function (evt) {
            if (!$wrapper.has(evt.target).length) {
                return;
            }
            $list.attr("aria-live", "polite");
            if (autoplay) {
                $slider.slick("slickPause");
            }
        });
        $wrapper.on("focusout", function (evt) {
            if (!$wrapper.has(evt.target).length) {
                return;
            }
            $list.removeAttr("aria-live");
            if (autoplay) {
                if ($(evt.target).hasClass(classes.closeVideoBtn)) {
                    return;
                }
                $slider.slick("slickPlay");
            }
        });
        if (obj.$dots) {
            obj.$dots.on("keydown", function (evt) {
                if (evt.which === 37) {
                    $slider.slick("slickPrev");
                }
                if (evt.which === 39) {
                    $slider.slick("slickNext");
                }
                if (evt.which === 37 || evt.which === 39) {
                    obj.$dots.find(".slick-active button").focus();
                }
            });
        }
    }
    function beforeChange(event, slick, currentSlide, nextSlide) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find("." + classes.currentSlide);
        var $nextSlide = $slider.find('.slideshow__slide[data-slick-index="' + nextSlide + '"]');
        if (isVideoInSlide($currentSlide)) {
            var $currentVideo = $currentSlide.find("." + classes.video);
            var currentVideoId = $currentVideo.attr("id");
            theme.SlideshowVideo.pauseVideo(currentVideoId);
            $currentVideo.attr("tabindex", "-1");
        }
        if (isVideoInSlide($nextSlide)) {
            var $video = $nextSlide.find("." + classes.video);
            var videoId = $video.attr("id");
            var isBackground = $video.hasClass(classes.videoBackground);
            if (isBackground) {
                theme.SlideshowVideo.playVideo(videoId);
            } else {
                $video.attr("tabindex", "0");
            }
        }
    }
    function isVideoInSlide($slide) {
        return $slide.find("." + classes.video).length;
    }
    slideshow.prototype.togglePause = function () {
        var slideshowSelector = getSlideshowId(this.$pause);
        if (this.$pause.hasClass(classes.isPaused)) {
            this.$pause.removeClass(classes.isPaused);
            $(slideshowSelector).slick("slickPlay");
        } else {
            this.$pause.addClass(classes.isPaused);
            $(slideshowSelector).slick("slickPause");
        }
    };
    function getSlideshowId($el) {
        return "#Slideshow-" + $el.data("id");
    }
    return slideshow;
})();
function onYouTubeIframeAPIReady() {
    theme.SlideshowVideo.loadVideos();
}
theme.SlideshowVideo = (function () {
    var autoplayCheckComplete = false;
    var autoplayAvailable = false;
    var playOnClickChecked = false;
    var playOnClick = false;
    var youtubeLoaded = false;
    var videos = {};
    var videoPlayers = [];
    var videoOptions = {
        ratio: 16 / 9,
        playerVars: { iv_load_policy: 3, modestbranding: 1, autoplay: 0, controls: 0, showinfo: 0, wmode: "opaque", branding: 0, autohide: 0, rel: 0 },
        events: { onReady: onPlayerReady, onStateChange: onPlayerChange },
    };
    var classes = {
        playing: "video-is-playing",
        paused: "video-is-paused",
        loading: "video-is-loading",
        loaded: "video-is-loaded",
        slideshowWrapper: "slideshow-wrapper",
        slide: "slideshow__slide",
        slideBackgroundVideo: "slideshow__slide--background-video",
        slideDots: "slick-dots",
        videoChrome: "slideshow__video--chrome",
        videoBackground: "slideshow__video--background",
        playVideoBtn: "slideshow__video-control--play",
        closeVideoBtn: "slideshow__video-control--close",
        currentSlide: "slick-current",
        slickClone: "slick-cloned",
        supportsAutoplay: "autoplay",
        supportsNoAutoplay: "no-autoplay",
    };
    function init($video) {
        if (!$video.length) {
            return;
        }
        videos[$video.attr("id")] = {
            id: $video.attr("id"),
            videoId: $video.data("id"),
            type: $video.data("type"),
            status: $video.data("type") === "chrome" ? "closed" : "background",
            videoSelector: $video.attr("id"),
            $parentSlide: $video.closest("." + classes.slide),
            $parentSlideshowWrapper: $video.closest("." + classes.slideshowWrapper),
            controls: $video.data("type") === "background" ? 0 : 1,
            slideshow: $video.data("slideshow"),
        };
        if (!youtubeLoaded) {
            var tag = document.createElement("script");
            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName("script")[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
    }
    function customPlayVideo(playerId) {
        if (!playOnClickChecked && !playOnClick) {
            return;
        }
        if (playerId && typeof videoPlayers[playerId].playVideo === "function") {
            privatePlayVideo(playerId);
        }
    }
    function pauseVideo(playerId) {
        if (videoPlayers[playerId] && typeof videoPlayers[playerId].pauseVideo === "function") {
            videoPlayers[playerId].pauseVideo();
        }
    }
    function loadVideos() {
        for (var key in videos) {
            if (videos.hasOwnProperty(key)) {
                var args = $.extend({}, videoOptions, videos[key]);
                args.playerVars.controls = args.controls;
                videoPlayers[key] = new YT.Player(key, args);
            }
        }
        initEvents();
        youtubeLoaded = true;
    }
    function loadVideo(key) {
        if (!youtubeLoaded) {
            return;
        }
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
        initEvents();
    }
    function privatePlayVideo(id, clicked) {
        var videoData = videos[id];
        var player = videoPlayers[id];
        var $slide = videos[id].$parentSlide;
        if (playOnClick) {
            setAsPlaying(videoData);
        } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
            $slide.removeClass(classes.loading);
            setAsPlaying(videoData);
            player.playVideo();
            return;
        }
        if (!autoplayCheckComplete) {
            autoplayCheckFunction(player, $slide);
        }
    }
    function setAutoplaySupport(supported) {
        var supportClass = supported ? classes.supportsAutoplay : classes.supportsNoAutoplay;
        $(document.documentElement).addClass(supportClass);
        if (!supported) {
            playOnClick = true;
        }
        autoplayCheckComplete = true;
    }
    function autoplayCheckFunction(player, $slide) {
        player.playVideo();
        autoplayTest(player)
            .then(function () {
                setAutoplaySupport(true);
            })
            .fail(function () {
                setAutoplaySupport(false);
                player.stopVideo();
            })
            .always(function () {
                autoplayCheckComplete = true;
                $slide.removeClass(classes.loading);
            });
    }
    function autoplayTest(player) {
        var deferred = $.Deferred();
        var wait;
        var timeout;
        wait = setInterval(function () {
            if (player.getCurrentTime() <= 0) {
                return;
            }
            autoplayAvailable = true;
            clearInterval(wait);
            clearTimeout(timeout);
            deferred.resolve();
        }, 500);
        timeout = setTimeout(function () {
            clearInterval(wait);
            deferred.reject();
        }, 4000);
        return deferred;
    }
    function playOnClickCheck() {
        if (playOnClickChecked) {
            return;
        }
        if ($(window).width() < 750) {
            playOnClick = true;
        } else if (window.mobileCheck()) {
            playOnClick = true;
        }
        if (playOnClick) {
            setAutoplaySupport(false);
        }
        playOnClickChecked = true;
    }
    function onPlayerReady(evt) {
        evt.target.setPlaybackQuality("hd1080");
        var videoData = getVideoOptions(evt);
        playOnClickCheck();
        $("#" + videoData.id).attr("tabindex", "-1");
        sizeBackgroundVideos();
        switch (videoData.type) {
            case "background-chrome":
            case "background":
                evt.target.mute();
                if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
                    privatePlayVideo(videoData.id);
                }
                break;
        }
        videoData.$parentSlide.addClass(classes.loaded);
    }
    function onPlayerChange(evt) {
        var videoData = getVideoOptions(evt);
        switch (evt.data) {
            case 0:
                setAsFinished(videoData);
                break;
            case 1:
                setAsPlaying(videoData);
                break;
            case 2:
                setAsPaused(videoData);
                break;
        }
    }
    function setAsFinished(videoData) {
        switch (videoData.type) {
            case "background":
                videoPlayers[videoData.id].seekTo(0);
                break;
            case "background-chrome":
                videoPlayers[videoData.id].seekTo(0);
                closeVideo(videoData.id);
                break;
            case "chrome":
                closeVideo(videoData.id);
                break;
        }
    }
    function setAsPlaying(videoData) {
        var $slideshow = videoData.$parentSlideshowWrapper;
        var $slide = videoData.$parentSlide;
        $slide.removeClass(classes.loading);
        if (videoData.status === "background") {
            return;
        }
        $("#" + videoData.id).attr("tabindex", "0");
        switch (videoData.type) {
            case "chrome":
            case "background-chrome":
                $slideshow.removeClass(classes.paused).addClass(classes.playing);
                $slide.removeClass(classes.paused).addClass(classes.playing);
                break;
        }
        $slide.find("." + classes.closeVideoBtn).focus();
    }
    function setAsPaused(videoData) {
        var $slideshow = videoData.$parentSlideshowWrapper;
        var $slide = videoData.$parentSlide;
        if (videoData.type === "background-chrome") {
            closeVideo(videoData.id);
            return;
        }
        if (videoData.status !== "closed" && videoData.type !== "background") {
            $slideshow.addClass(classes.paused);
            $slide.addClass(classes.paused);
        }
        if (videoData.type === "chrome" && videoData.status === "closed") {
            $slideshow.removeClass(classes.paused);
            $slide.removeClass(classes.paused);
        }
        $slideshow.removeClass(classes.playing);
        $slide.removeClass(classes.playing);
    }
    function closeVideo(playerId) {
        var videoData = videos[playerId];
        var $slideshow = videoData.$parentSlideshowWrapper;
        var $slide = videoData.$parentSlide;
        var classesToRemove = [classes.pause, classes.playing].join(" ");
        $("#" + videoData.id).attr("tabindex", "-1");
        videoData.status = "closed";
        switch (videoData.type) {
            case "background-chrome":
                videoPlayers[playerId].mute();
                setBackgroundVideo(playerId);
                break;
            case "chrome":
                videoPlayers[playerId].stopVideo();
                setAsPaused(videoData);
                break;
        }
        $slideshow.removeClass(classesToRemove);
        $slide.removeClass(classesToRemove);
    }
    function getVideoOptions(evt) {
        return videos[evt.target.h.id];
    }
    function startVideoOnClick(playerId) {
        var videoData = videos[playerId];
        videoData.$parentSlide.addClass(classes.loading);
        videoData.status = "open";
        switch (videoData.type) {
            case "background-chrome":
                unsetBackgroundVideo(playerId, videoData);
                videoPlayers[playerId].unMute();
                privatePlayVideo(playerId, true);
                break;
            case "chrome":
                privatePlayVideo(playerId, true);
                break;
        }
        $(document).on("keydown.videoPlayer", function (evt) {
            if (evt.keyCode === 27) {
                closeVideo(playerId);
            }
        });
    }
    function sizeBackgroundVideos() {
        $("." + classes.videoBackground).each(function (index, el) {
            sizeBackgroundVideo($(el));
        });
    }
    function sizeBackgroundVideo($player) {
        var $slide = $player.closest("." + classes.slide);
        if ($slide.hasClass(classes.slickClone)) {
            return;
        }
        var slideWidth = $slide.width();
        var playerWidth = $player.width();
        var playerHeight = $player.height();
        if (slideWidth / videoOptions.ratio < playerHeight) {
            playerWidth = Math.ceil(playerHeight * videoOptions.ratio);
            $player
                .width(playerWidth)
                .height(playerHeight)
                .css({ left: (slideWidth - playerWidth) / 2, top: 0 });
        } else {
            playerHeight = Math.ceil(slideWidth / videoOptions.ratio);
            $player
                .width(slideWidth)
                .height(playerHeight)
                .css({ left: 0, top: (playerHeight - playerHeight) / 2 });
        }
        $player.prepareTransition().addClass(classes.loaded);
    }
    function unsetBackgroundVideo(playerId) {
        $("#" + playerId)
            .removeAttr("style")
            .removeClass(classes.videoBackground)
            .addClass(classes.videoChrome);
        videos[playerId].$parentSlideshowWrapper.removeClass(classes.slideBackgroundVideo).addClass(classes.playing);
        videos[playerId].$parentSlide.removeClass(classes.slideBackgroundVideo).addClass(classes.playing);
        videos[playerId].status = "open";
    }
    function setBackgroundVideo(playerId) {
        var $player = $("#" + playerId)
            .addClass(classes.videoBackground)
            .removeClass(classes.videoChrome);
        videos[playerId].$parentSlide.addClass(classes.slideBackgroundVideo);
        videos[playerId].status = "background";
        sizeBackgroundVideo($player);
    }
    function initEvents() {
        $(document).on("click.videoPlayer", "." + classes.playVideoBtn, function (evt) {
            var playerId = $(evt.currentTarget).data("controls");
            startVideoOnClick(playerId);
        });
        $(document).on("click.videoPlayer", "." + classes.closeVideoBtn, function (evt) {
            var playerId = $(evt.currentTarget).data("controls");
            closeVideo(playerId);
        });
        $(window).on(
            "resize.videoPlayer",
            $.debounce(250, function () {
                if (youtubeLoaded) {
                    sizeBackgroundVideos();
                }
            })
        );
    }
    function removeEvents() {
        $(document).off(".videoPlayer");
        $(window).off(".videoPlayer");
    }
    return { init: init, loadVideos: loadVideos, loadVideo: loadVideo, playVideo: customPlayVideo, pauseVideo: pauseVideo, removeEvents: removeEvents };
})();
(function () {
    var $filterBy = $("#BlogTagFilter");
    if (!$filterBy.length) {
        return;
    }
    $filterBy.on("change", function () {
        location.href = $(this).val();
    });
})();
window.theme = theme || {};
theme.customerTemplates = (function () {
    function initEventListeners() {
        $("#RecoverPassword").on("click", function (evt) {
            evt.preventDefault();
            toggleRecoverPasswordForm();
        });
        $("#HideRecoverPasswordLink").on("click", function (evt) {
            evt.preventDefault();
            toggleRecoverPasswordForm();
        });
    }
    function toggleRecoverPasswordForm() {
        $("#RecoverPasswordForm").toggleClass("hide");
        $('.reset-password-image').toggleClass("hide");

        $("#CustomerLoginForm").toggleClass("hide");
        $('.login-image').toggleClass("hide");

    }
    function resetPasswordSuccess() {
        var $formState = $(".reset-password-success");
        if (!$formState.length) {
            return;
        }
        $("#ResetSuccess").removeClass("hide");
    }
    function customerAddressForm() {
        var $newAddressForm = $("#AddressNewForm");
        if (!$newAddressForm.length) {
            return;
        }
        if (Shopify) {
            new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", { hideElement: "AddressProvinceContainerNew" });
        }
        $(".address-country-option").each(function () {
            var formId = $(this).data("form-id");
            var countrySelector = "AddressCountry_" + formId;
            var provinceSelector = "AddressProvince_" + formId;
            var containerSelector = "AddressProvinceContainer_" + formId;
            new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, { hideElement: containerSelector });
        });
        $(".address-new-toggle").on("click", function () {
            $newAddressForm.toggleClass("hide");
        });
        $(".address-edit-toggle").on("click", function () {
            var formId = $(this).data("form-id");
            $("#EditAddress_" + formId).toggleClass("hide");
        });
        $(".address-delete").on("click", function () {
            var $el = $(this);
            var formId = $el.data("form-id");
            var confirmMessage = $el.data("confirm-message");
            if (confirm(confirmMessage || "Are you sure you wish to delete this address?")) {
                Shopify.postLink("/account/addresses/" + formId, { parameters: { _method: "delete" } });
            }
        });
    }
    function checkUrlHash() {
        var hash = window.location.hash;
        if (hash === "#recover") {
            toggleRecoverPasswordForm();
        }
    }
    return {
        init: function () {
            checkUrlHash();
            initEventListeners();
            resetPasswordSuccess();
            customerAddressForm();
        },
    };
})();
window.theme = window.theme || {};
theme.Cart = (function () {
    var selectors = { edit: ".js-edit-toggle" };
    var config = { showClass: "cart__update--show", showEditClass: "cart__edit--active", cartNoCookies: "cart--no-cookies" };
    function Cart(container) {
        this.$container = $(container);
        this.$edit = $(selectors.edit, this.$container);
        if (!this.cookiesEnabled()) {
            this.$container.addClass(config.cartNoCookies);
        }
        this.$edit.on("click", this._onEditClick.bind(this));
    }
    Cart.prototype = _.assignIn({}, Cart.prototype, {
        onUnload: function () {
            this.$edit.off("click", this._onEditClick);
        },
        _onEditClick: function (evt) {
            var $evtTarget = $(evt.target);
            var $updateLine = $("." + $evtTarget.data("target"));
            $evtTarget.toggleClass(config.showEditClass);
            $updateLine.toggleClass(config.showClass);
        },
        cookiesEnabled: function () {
            var cookieEnabled = navigator.cookieEnabled;
            if (!cookieEnabled) {
                document.cookie = "testcookie";
                cookieEnabled = document.cookie.indexOf("testcookie") !== -1;
            }
            return cookieEnabled;
        },
    });
    return Cart;
})();
window.theme = window.theme || {};
theme.Filters = (function () {
    var constants = { SORT_BY: "sort_by" };
    var selectors = { filterSelection: ".filters-toolbar__input--filter", sortSelection: ".filters-toolbar__input--sort", defaultSort: ".collection-header__default-sort" };
    function Filters(container) {
        var $container = (this.$container = $(container));
        this.$filterSelect = $(selectors.filterSelection, $container);
        this.$sortSelect = $(selectors.sortSelection, $container);
        this.$selects = $(selectors.filterSelection, $container).add($(selectors.sortSelection, $container));
        this.defaultSort = this._getDefaultSortValue();
        this._resizeSelect(this.$selects);
        this.$selects.removeClass("hidden");
        this.$filterSelect.on("change", this._onFilterChange.bind(this));
        this.$sortSelect.on("change", this._onSortChange.bind(this));
    }
    Filters.prototype = _.assignIn({}, Filters.prototype, {
        _onSortChange: function (evt) {
            var sort = this._sortValue();
            if (sort.length) {
                window.location.search = sort;
            } else {
                window.location.href = window.location.href.replace(window.location.search, "");
            }
            this._resizeSelect($(evt.target));
        },
        _onFilterChange: function (evt) {
            window.location.href = this.$filterSelect.val() + window.location.search;
            this._resizeSelect($(evt.target));
        },
        _getSortValue: function () {
            return this.$sortSelect.val() || this.defaultSort;
        },
        _getDefaultSortValue: function () {
            return $(selectors.defaultSort, this.$container).val();
        },
        _sortValue: function () {
            var sort = this._getSortValue();
            var query = "";
            if (sort !== this.defaultSort) {
                query = constants.SORT_BY + "=" + sort;
            }
            return query;
        },
        _resizeSelect: function ($selection) {
            $selection.each(function () {
                var $this = $(this);
                var arrowWidth = 10;
                var text = $this.find("option:selected").text();
                var $test = $("<span>").html(text);
                $test.appendTo("body");
                var width = $test.width();
                $test.remove();
                $this.width(width + arrowWidth);
            });
        },
        onUnload: function () {
            this.$filterSelect.off("change", this._onFilterChange);
            this.$sortSelect.off("change", this._onSortChange);
        },
    });
    return Filters;
})();
window.theme = window.theme || {};
theme.HeaderSection = (function () {
    function Header() {
        theme.Header.init();
        theme.MobileNav.init();
        theme.Search.init();
    }
    Header.prototype = _.assignIn({}, Header.prototype, {
        onUnload: function () {
            theme.Header.unload();
        },
    });
    return Header;
})();
theme.Maps = (function () {
    var config = { zoom: 14 };
    var apiStatus = null;
    var mapsToLoad = [];
    var key = theme.mapKey ? theme.mapKey : "";
    function Map(container) {
        this.$container = $(container);
        if (apiStatus === "loaded") {
            this.createMap();
        } else {
            mapsToLoad.push(this);
            if (apiStatus !== "loading") {
                apiStatus = "loading";
                if (typeof window.google === "undefined") {
                    $.getScript("https://maps.googleapis.com/maps/api/js?key=" + key).then(function () {
                        apiStatus = "loaded";
                        initAllMaps();
                    });
                }
            }
        }
    }
    function initAllMaps() {
        $.each(mapsToLoad, function (index, instance) {
            instance.createMap();
        });
    }
    function geolocate($map) {
        var deferred = $.Deferred();
        var geocoder = new google.maps.Geocoder();
        var address = $map.data("address-setting");
        geocoder.geocode({ address: address }, function (results, status) {
            if (status !== google.maps.GeocoderStatus.OK) {
                deferred.reject(status);
            }
            deferred.resolve(results);
        });
        return deferred;
    }
    Map.prototype = _.assignIn({}, Map.prototype, {
        createMap: function () {
            var $map = this.$container.find(".map-section__container");
            return geolocate($map)
                .then(
                    function (results) {
                        var mapOptions = { zoom: config.zoom, center: results[0].geometry.location, disableDefaultUI: true };
                        var map = (this.map = new google.maps.Map($map[0], mapOptions));
                        var center = (this.center = map.getCenter());
                        var marker = new google.maps.Marker({ map: map, position: map.getCenter() });
                        google.maps.event.addDomListener(
                            window,
                            "resize",
                            $.debounce(250, function () {
                                google.maps.event.trigger(map, "resize");
                                map.setCenter(center);
                            })
                        );
                    }.bind(this)
                )
                .fail(function () {
                    var errorMessage;
                    switch (status) {
                        case "ZERO_RESULTS":
                            errorMessage = theme.strings.addressNoResults;
                            break;
                        case "OVER_QUERY_LIMIT":
                            errorMessage = theme.strings.addressQueryLimit;
                            break;
                        default:
                            errorMessage = theme.strings.addressError;
                            break;
                    }
                    $map.parent()
                        .addClass("page-width map-section--load-error")
                        .html('<div class="errors text-center">' + errorMessage + "</div>");
                });
        },
        onUnload: function () {
            google.maps.event.clearListeners(this.map, "resize");
        },
    });
    return Map;
})();
function gm_authFailure() {
    $(".map-section").addClass("map-section--load-error");
    $(".map-section__container").remove();
    $(".map-section__link").remove();
    $(".map-section__overlay").after('<div class="errors text-center">' + theme.strings.authError + "</div>");
}
theme.Product = (function () {
    function Product(container) {
        var $container = (this.$container = $(container));
        var sectionId = $container.attr("data-section-id");
        this.settings = {
            mediaQueryMediumUp: "screen and (min-width: 750px)",
            mediaQuerySmall: "screen and (max-width: 749px)",
            bpSmall: false,
            enableHistoryState: $container.data("enable-history-state") || false,
            imageSize: null,
            imageZoomSize: null,
            namespace: ".slideshow-" + sectionId,
            sectionId: sectionId,
            sliderActive: false,
            zoomEnabled: false,
        };
        this.selectors = {
            addToCart: "#AddToCart-" + sectionId,
            addToCartText: "#AddToCartText-" + sectionId,
            comparePrice: "#ComparePrice-" + sectionId,
            originalPrice: "#ProductPrice-" + sectionId,
            SKU: ".variant-sku",
            originalPriceWrapper: ".product-price__price-" + sectionId,
            originalSelectorId: "#ProductSelect-" + sectionId,
            productFeaturedImage: "#FeaturedImage-" + sectionId,
            productImageWrap: "#FeaturedImageZoom-" + sectionId,
            productPrices: ".product-single__price-" + sectionId,
            productThumbImages: ".product-single__thumbnail--" + sectionId,
            productThumbs: ".product-single__thumbnails-" + sectionId,
            saleClasses: "product-price__sale product-price__sale--single",
            saleLabel: ".product-price__sale-label-" + sectionId,
            singleOptionSelector: ".single-option-selector-" + sectionId,
        };
        if (!$("#ProductJson-" + sectionId).html()) {
            return;
        }
        this.productSingleObject = JSON.parse(document.getElementById("ProductJson-" + sectionId).innerHTML);
        this.settings.zoomEnabled = $(this.selectors.productFeaturedImage).hasClass("js-zoom-enabled");
        // this.settings.imageSize = theme.Images.imageSize($(this.selectors.productFeaturedImage).attr("src"));
        if (this.settings.zoomEnabled) {
            this.settings.imageZoomSize = theme.Images.imageSize($(this.selectors.productImageWrap).data("zoom"));
        }
        this._initBreakpoints();
        this._stringOverrides();
        this._initVariants();
        this._initImageSwitch();
        this._setActiveThumbnail();
        this._initThumbnailSlider();
        theme.Images.preload(this.productSingleObject.images, this.settings.imageSize);
    }
    Product.prototype = _.assignIn({}, Product.prototype, {
        _stringOverrides: function () {
            theme.productStrings = theme.productStrings || {};
            $.extend(theme.strings, theme.productStrings);
        },
        _initBreakpoints: function () {
            var self = this;
            enquire.register(this.settings.mediaQuerySmall, {
                match: function () {
                    /*if ($(self.selectors.productThumbImages).length > 3) {
                        self._initThumbnailSlider();
                    }*/
                    if (self.settings.zoomEnabled) {
                        _destroyZoom($(self.selectors.productImageWrap));
                    }
                    self.settings.bpSmall = true;
                },
                unmatch: function () {
                    if (self.settings.sliderActive) {
                        self._destroyThumbnailSlider();
                    }
                    self.settings.bpSmall = false;
                },
            });
            enquire.register(this.settings.mediaQueryMediumUp, {
                match: function () {
                    if (self.settings.zoomEnabled) {
                        _enableZoom($(self.selectors.productImageWrap));
                    }
                },
            });
        },
        _initVariants: function () {
            var options = {
                $container: this.$container,
                enableHistoryState: this.$container.data("enable-history-state") || false,
                singleOptionSelector: this.selectors.singleOptionSelector,
                originalSelectorId: this.selectors.originalSelectorId,
                product: this.productSingleObject,
            };
            this.variants = new slate.Variants(options);
            this.$container.on("variantChange" + this.settings.namespace, this._updateAddToCart.bind(this));
            this.$container.on("variantImageChange" + this.settings.namespace, this._updateImages.bind(this));
            this.$container.on("variantPriceChange" + this.settings.namespace, this._updatePrice.bind(this));
            this.$container.on("variantSKUChange" + this.settings.namespace, this._updateSKU.bind(this));
        },
        _initImageSwitch: function () {
            if (!$(this.selectors.productThumbImages).length) {
                return;
            }
            var self = this;
            $(this.selectors.productThumbImages).on("click", function (evt) {
                evt.preventDefault();
                var $el = $(this);
                var imageSrc = $el.attr("href");
                var zoomSrc = $el.data("zoom");
                self._switchImage(imageSrc, zoomSrc);
                self._setActiveThumbnail(imageSrc);
            });
        },
        _setActiveThumbnail: function (src) {
            var activeClass = "active-thumb";
            if (typeof src === "undefined") {
                src = $(this.selectors.productFeaturedImage).attr("src");
            }
            var $thumbnail = $(this.selectors.productThumbImages + '[href="' + src + '"]');
            $(this.selectors.productThumbImages).removeClass(activeClass);
            $thumbnail.addClass(activeClass);
        },
        _switchImage: function (image, zoomImage) {
            $(this.selectors.productFeaturedImage).attr("src", image);
            if (this.settings.zoomEnabled) {
                _destroyZoom($(this.selectors.productImageWrap));
            }
            if (!this.settings.bpSmall && this.settings.zoomEnabled && zoomImage) {
                $(this.selectors.productImageWrap).data("zoom", zoomImage);
                _enableZoom($(this.selectors.productImageWrap));
            }
        },
        _initThumbnailSlider: function () {
            var options = {
                slidesToShow: 4,
                slidesToScroll: 3,
                infinite: false,
                prevArrow: ".thumbnails-slider__prev--" + this.settings.sectionId,
                nextArrow: ".thumbnails-slider__next--" + this.settings.sectionId,
                responsive: [{ breakpoint: 321, settings: { slidesToShow: 3 } }],
            };
            $(this.selectors.productThumbs).slick(options);
            this.settings.sliderActive = true;
        },
        _destroyThumbnailSlider: function () {
            $(this.selectors.productThumbs).slick("unslick");
            this.settings.sliderActive = false;
        },
        _updateAddToCart: function (evt) {
            var variant = evt.variant;
            if (variant) {
                $(this.selectors.productPrices).removeClass("visibility-hidden").attr("aria-hidden", "true");
                if (variant.available) {
                    if($('.product-template__container[data-disabled-us-product="true"]').length > 0) {
                        $('#sticky-btn').prop("disabled", true);
                        $(this.selectors.addToCart).prop("disabled", true);
                        $(this.selectors.addToCartText).text("Unavailable In Region");
                        $('#sticky-btn').text("Unavailable In Region");
                    }
                    else {
                        $('#sticky-btn').prop("disabled", false);
                        $(this.selectors.addToCart).prop("disabled", false);
                        $(this.selectors.addToCartText).text("Add to Cart");
                        $('#sticky-btn').text("Add to Cart");
                    }
                } else {
                    $('#sticky-btn').prop("disabled", true);
                    $(this.selectors.addToCart).prop("disabled", true);
                    $(this.selectors.addToCartText).text("Sold Out");
                    $('#sticky-btn').text("Sold Out");
                }
            } else {
                $(this.selectors.addToCart).prop("disabled", true);
                $('#sticky-btn').prop("disabled", true);
                $(this.selectors.addToCartText).text(theme.strings.unavailable);
                $('#sticky-btn').text(theme.strings.unavailable);
                $(this.selectors.productPrices).addClass("visibility-hidden").attr("aria-hidden", "false");
            }
        },
        _updateImages: function (evt) {
            var variant = evt.variant;
            var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
            var zoomSizedImgUrl;
            sizedImgUrl = "https:" + sizedImgUrl;
            // console.log(sizedImgUrl);
            if (this.settings.zoomEnabled) {
                zoomSizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageZoomSize);
            }
            this._switchImage(sizedImgUrl, zoomSizedImgUrl);
            this._setActiveThumbnail(sizedImgUrl);
            $('.active-magic-slide img').attr('src', sizedImgUrl);
        },
        _updatePrice: function (evt) {
            var variant = evt.variant;
            $(this.selectors.originalPrice).html(theme.Currency.formatMoney(variant.price, theme.moneyFormat));
            
            
            if (variant.compare_at_price > variant.price) {
                $(this.selectors.comparePrice).html(theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat)).removeClass("hide");
                $(this.selectors.originalPriceWrapper).addClass(this.selectors.saleClasses);
                $(this.selectors.saleLabel).removeClass("hide");
                var percentage = Math.round(((variant.compare_at_price - variant.price) * 100 ) / variant.compare_at_price);
                console.log('hit price =',percentage);
                $('span.product-is-on-sale.product-price__sale-label.product-price__sale-label-product-template').text('SAVE '+percentage+'%');
            } else {
                $(this.selectors.comparePrice).addClass("hide");
                $(this.selectors.saleLabel).addClass("hide");
                $(this.selectors.originalPriceWrapper).removeClass(this.selectors.saleClasses);
            }
        },
        _updateSKU: function (evt) {
            var variant = evt.variant;
            $(this.selectors.SKU).html(variant.sku);
        },
        onUnload: function () {
            this.$container.off(this.settings.namespace);
        },
    });
    function _enableZoom($el) {
        var zoomUrl = $el.data("zoom");
        $el.zoom({ url: zoomUrl });
    }
    function _destroyZoom($el) {
        $el.trigger("zoom.destroy");
    }
    return Product;
})();
theme.Quotes = (function () {
    var config = { mediaQuerySmall: "screen and (max-width: 749px)", mediaQueryMediumUp: "screen and (min-width: 750px)", slideCount: 0 };
    var defaults = { accessibility: true, arrows: false, dots: true, autoplay: false, touchThreshold: 20, slidesToShow: 3, slidesToScroll: 3 };
    function Quotes(container) {
        var $container = (this.$container = $(container));
        var sectionId = $container.attr("data-section-id");
        var wrapper = (this.wrapper = ".quotes-wrapper");
        var slider = (this.slider = "#Quotes-" + sectionId);
        var $slider = $(slider, wrapper);
        var sliderActive = false;
        var mobileOptions = $.extend({}, defaults, { slidesToShow: 1, slidesToScroll: 1, adaptiveHeight: true });
        config.slideCount = $slider.data("count");
        if (config.slideCount < defaults.slidesToShow) {
            defaults.slidesToShow = config.slideCount;
            defaults.slidesToScroll = config.slideCount;
        }
        $slider.on("init", this.a11y.bind(this));
        enquire.register(config.mediaQuerySmall, {
            match: function () {
                initSlider($slider, mobileOptions);
            },
        });
        enquire.register(config.mediaQueryMediumUp, {
            match: function () {
                initSlider($slider, defaults);
            },
        });
        function initSlider(sliderObj, args) {
            if (sliderActive) {
                sliderObj.slick("unslick");
                sliderActive = false;
            }
            sliderObj.slick(args);
            sliderActive = true;
        }
    }
    Quotes.prototype = _.assignIn({}, Quotes.prototype, {
        onUnload: function () {
            enquire.unregister(config.mediaQuerySmall);
            enquire.unregister(config.mediaQueryMediumUp);
            $(this.slider, this.wrapper).slick("unslick");
        },
        onBlockSelect: function (evt) {
            var $slide = $(".quotes-slide--" + evt.detail.blockId + ":not(.slick-cloned)");
            var slideIndex = $slide.data("slick-index");
            $(this.slider, this.wrapper).slick("slickGoTo", slideIndex);
        },
        a11y: function (event, obj) {
            var $list = obj.$list;
            var $wrapper = $(this.wrapper, this.$container);
            $list.removeAttr("aria-live");
            $wrapper.on("focusin", function (evt) {
                if ($wrapper.has(evt.target).length) {
                    $list.attr("aria-live", "polite");
                }
            });
            $wrapper.on("focusout", function (evt) {
                if ($wrapper.has(evt.target).length) {
                    $list.removeAttr("aria-live");
                }
            });
        },
    });
    return Quotes;
})();
theme.slideshows = {};
theme.SlideshowSection = (function () {
    function SlideshowSection(container) {
        var $container = (this.$container = $(container));
        var sectionId = $container.attr("data-section-id");
        var slideshow = (this.slideshow = "#Slideshow-" + sectionId);
        $(".slideshow__video", slideshow).each(function () {
            var $el = $(this);
            theme.SlideshowVideo.init($el);
            theme.SlideshowVideo.loadVideo($el.attr("id"));
        });
        theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
    }
    return SlideshowSection;
})();
theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
    onUnload: function () {
        delete theme.slideshows[this.slideshow];
    },
    onBlockSelect: function (evt) {
        var $slideshow = $(this.slideshow);
        var $slide = $(".slideshow__slide--" + evt.detail.blockId + ":not(.slick-cloned)");
        var slideIndex = $slide.data("slick-index");
        $slideshow.slick("slickGoTo", slideIndex).slick("slickPause");
    },
    onBlockDeselect: function () {
        $(this.slideshow).slick("slickPlay");
    },
});
$(document).ready(function () {
    var sections = new theme.Sections();
    sections.register("cart-template", theme.Cart);
    sections.register("product", theme.Product);
    sections.register("collection-template", theme.Filters);
    sections.register("product-template", theme.Product);
    sections.register("header-section", theme.HeaderSection);
    sections.register("map", theme.Maps);
    sections.register("slideshow-section", theme.SlideshowSection);
    sections.register("quotes", theme.Quotes);
    sections.register('product-recommendations', theme.ProductRecommendations);
});
theme.init = function () {
    theme.customerTemplates.init();
    slate.rte.wrapTable();
    slate.rte.iframeReset();
    slate.a11y.pageLinkFocus($(window.location.hash));
    $(".in-page-link").on("click", function (evt) {
        slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });
    $('a[href="#"]').on("click", function (evt) {
        evt.preventDefault();
    });
};
$(theme.init);

// footer accordion
$('.site-footer__linklist h4').click(function() {
    if ($(window).width() < 769) {
        $(this).next().slideToggle();
        $(this).toggleClass('active');
    }
});

/***************** Trending Products Slider *****************/
function initTrendingSlider() {
    if($(window).width() < 769) {
        var $cellAlign = 'center';
        $initialIndex = 1
    }
    else {
        var $cellAlign = 'left';
        $initialIndex = 0
    }
    let options = {
        cellAlign: $cellAlign,
        freeScroll: false,
        pageDots: false,
        groupCells: true,
        initialIndex: $initialIndex
    };
    $('.trending-products-slider').flickity(options).flickity('resize');
}
/*
$(document).arrive('.trending-products .spr-badge', function() {
  $('.trending-products-slider').show();
  initTrendingSlider();
})
*/
$(window).load(function() {
    $('.trending-products-slider').show();
    initTrendingSlider();
});

/***************** Notifications Slider *****************/
function initNotificationsSlider() {
    var autoPlayIntervals = [
        4000,
        5000,
        5000,
    ];

    var $carousel = $('.notifications-bar-slider').flickity({
        autoPlay: autoPlayIntervals[0],
        wrapAround: true,
        cellAlign: 'center',
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        selectedAttraction: 0.015
      });
      var flkty = $carousel.data('flickity');
      
      $carousel.on( 'select.flickity', function() {
        // set custom autoPlay interval
        // default is 1500ms
        flkty.options.autoPlay = autoPlayIntervals[ flkty.selectedIndex ] || 2500;
      });
      
    $('.carousel-cell').addClass('pageloaded');
    
}

$(window).load(function() {
    $('.notifications-bar-slider').show();
    initNotificationsSlider();
});


/***************** Title Columns Button Section Mobile Slider *****************/
function titleColumnsButtonMobileSlider() {
    if($(window).width() < 769) {
        let options = {
            watchCSS: true,
            cellAlign: 'center',
            freeScroll: false,
            pageDots: true,
            prevNextButtons: false,
            wrapAround: true,
            autoPlay: true
        };

        $('.title-columns-button-section .column-items-wrapper').flickity(options);
    }
}
$(document).ready(function (){
    if($('.title-columns-button-section .column-items-wrapper').length > 0){
        titleColumnsButtonMobileSlider();
    }
})
/************************* Mega Menu *************************/
//Initialise mega menu, clone under parent link
$('.mega-menu[data-parent-link]').each(function() {
    var parentLink = $(this).data('parent-link');
    var $parentElement = $('#shopify-section-header .site-nav li[data-navlink-handle="' + parentLink + '"]');
    var $megaMenu = $(this).closest('.mega-menu__section');
    $parentElement.addClass('has-mega-menu');
    $parentElement.find('.mega-menu__section').remove();

    $megaMenu.clone().appendTo($parentElement);

    var $parentMobileElement = $('[data-mobile-menu-navlink-handle="' + parentLink + '"]');
    var $mobileElement = $('#MobileNav');
    $parentMobileElement.find('.submenu__label').addClass('has-mega-menu'); // Find data attribute for toggle and assign it true
    $mobileElement.after('<ul data-mobilesubmenu-handle="' + parentLink + '" class="mobile-submenu__list mobile-menu__submenu has-mega-menu" data-mobile-submenu-first-level-list></ul>');

    /* Submenu is present - add mega menu elements and remove current sub-menu */
    var _$parentList = $('.mobile-nav-wrapper').find('[data-mobile-submenu-first-level-list][data-mobilesubmenu-handle="' + parentLink + '"]');
    _$parentList.empty().addClass('has-mega-menu'); // Insert mega menu
    $megaMenu.clone().appendTo(_$parentList);
});

$('.mobile-nav-image').insertBefore($('.parentlink_accordion_on_mobile').first());
$('.megamenu-mobile').last().addClass('last');

$(".parentlink_accordion_on_mobile").on("click", function (e) {
    $(this).toggleClass('is-active');
});

$(".mega-menu__mobile-title").on("click", function (e) {
    $('body').find('.mobile-submenu__list').removeClass('active');
});

//end

$('#shopify-section-header .site-nav li')
.on('mouseover', function () {
    //Close any mega menus on hover
    $('.mega-menu__section').removeClass('is-active');
    $('body').removeClass('menu-is-active');

    if ($(this).hasClass('has-mega-menu')) {
        const childLink = $(this).data('navlink-handle');
        const $childElement = $('.mega-menu[data-parent-link="' + childLink + '"]').closest('.mega-menu__section');
        //Toggle corresponding mega menu
        $childElement.addClass('is-active');
        $('body').addClass('menu-is-active');
        //Add class active-menu to the trigger
        $(this).addClass('active-menu');
    }
}).on('mouseleave', function () {
    //Hide mega menu upon leaving mega menu, logo or navbar
    $('.mega-menu__section').removeClass('is-active');
    $(this).removeClass('active-menu');
    $('body').removeClass('menu-is-active');
});

$(".submenu__label.has-mega-menu .mobile-nav__link").on("click", function (e) {
    e.preventDefault();
    var submenuHandle = $(this).closest('.mobile-nav__item').data('mobile-menu-navlink-handle');
    $('body')
        .find('.mobile-submenu__list[data-mobilesubmenu-handle="' + submenuHandle + '"]')
        .addClass('active');
});

//wait for cbb class exists, then change cbb button class
var checkCBBExist = setInterval(function() {
    if($('body.cbb-desktop-button').length > 0 || $('body.cbb-mobile-button').length > 0){
        changeCbbButtonClass();

        $(window).on('resize', function(){
            changeCbbButtonClass();
        });

        //stop checking for CBB class
        clearInterval(checkCBBExist);
    }
 }, 500);

function changeCbbButtonClass(){
    if($(window).width() <= 992){
        $('body').removeClass('cbb-desktop-button');
        $('body').addClass('cbb-mobile-button');
    }
    else{
        $('body').removeClass('cbb-mobile-button');
        $('body').addClass('cbb-desktop-button');
    }
}

/******************* Sticky Header on scroll *******************/
$(function() {
    checkScrollPosition();
    $(window).load(function() {
        checkScrollPosition();
        $(window).scroll(function() {
            var scroll = $(window).scrollTop();
            if (scroll > 0) {
                $('body').addClass('sticky-header');
            } else {
                $('body').removeClass('sticky-header');
            }
        });
    });


    $('#shopify-section-header').on("hover", function () {
        var scroll = $(window).scrollTop();
        if (scroll > 0) {
            $('body').removeClass('sticky-header');
        }
    });

    $('#shopify-section-header').on("blur", function () {
        var scroll = $(window).scrollTop();
        if (scroll > 0) {
            $('body').addClass('sticky-header');
        }
    });

    $('#shopify-section-header .site-nav li').on("mouseover", function () {
        $('#AccessibleNav').addClass('nav-hover');
    });

    $('#shopify-section-header .site-nav li').on("mouseout", function () {
        $('#AccessibleNav').removeClass('nav-hover');
    });   
    
    // Hide Header on on scroll down
    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = 30;$('#shopify-section-header').outerHeight();

    $(window).scroll(function(event){
        didScroll = true;
    });

    setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);
    
    setMainContainerPosition();
    $(window).resize($.debounce(250,function() {
        setMainContainerPosition();
    }));

    function setMainContainerPosition() {
        // Get header height for non-index pages
        //if (!$('body').hasClass('template-index')) {
            var headerHeight = $('#shopify-section-header').outerHeight();
            $('body').css('padding-top',headerHeight);
        //}
    }
    
    function hasScrolled() {
        var st = $(this).scrollTop();
        
        if(Math.abs(lastScrollTop - st) <= delta)
            return;
        
        // If scrolled down past the navbar, add class
        if (st > lastScrollTop && st > navbarHeight){
            // Scroll Down
            $('body').removeClass('nav-up').addClass('nav-down');
        } else {
            // Scroll Up
            if(st + $(window).height() < $(document).height()) {
                $('body').removeClass('nav-down').addClass('nav-up');
            }
        }
        
        lastScrollTop = st;
    }

    function checkScrollPosition() {
        var scroll = $(window).scrollTop();
        if (scroll > 30) {
            $('body').removeClass('nav-down').addClass('nav-up sticky-header');
        }
    }
});

/******************* Slider with sidebar *******************/

// https://github.com/jjenzz/jquery.ellipsis, https://codepen.io/jjenzz/pen/liAfz
!function(e){"function"==typeof define&&define.amd?define(["jquery"],e):e(jQuery)}(function(h){var $="ellipsis",d='<span style="white-space: nowrap;">',m={lines:"auto",ellipClass:"ellip",responsive:!1};function t(e,t){var s,n,i,l,o,p,a,r=this,u=0,c=[];function f(){var e;"number"==typeof r.opts.lines&&r.opts.lines<2?r.$el.addClass(r.opts.ellipLineClass):(o=r.$cont.height(),"auto"===r.opts.lines&&r.$el.prop("scrollHeight")<=o||a&&(p=h.trim(r.text).split(/\s+/),r.$el.html(d+p.join("</span> "+d)+"</span>"),r.$el.find("span").each(a),null!=s&&(p[e=s]='<span class="'+r.opts.ellipLineClass+'">'+p[e],p.push("</span>"),r.$el.html(p.join(" ")))))}r.$cont=h(e),r.opts=h.extend({},m,t),"auto"===r.opts.lines&&(a=function(e,t){var n=h(t),t=n.position().top;if(l=l||n.height(),t===i?c[u].push(n):(i=t,c[u+=1]=[n]),o<t+l)return s=e-c[u-1].length,!1}),"number"==typeof r.opts.lines&&1<r.opts.lines&&(a=function(e,t){t=h(t).position().top;if(t!==i&&(i=t,u+=1),u===r.opts.lines)return s=e,!1}),r.opts.responsive&&h(window).on("resize."+$,function(){c=[],u=0,s=i=null,r.$el.html(r.text),clearTimeout(n),n=setTimeout(f,100)}),r.text=r.$cont.text(),r.opts.ellipLineClass=r.opts.ellipClass+"-line",r.$el=h('<span class="'+r.opts.ellipClass+'" />'),r.$el.text(r.text),r.$cont.empty().append(r.$el),f()}h.fn[$]=function(e){return this.each(function(){try{h(this).data($,new t(this,e))}catch(e){window.console&&console.error($+": "+e)}})}});
/*
* jquery-match-height 0.7.2 by @liabru
* http://brm.io/jquery-match-height/
* License MIT
*/
!function(t){"use strict";"function"==typeof define&&define.amd?define(["jquery"],t):"undefined"!=typeof module&&module.exports?module.exports=t(require("jquery")):t(jQuery)}(function(t){var e=-1,o=-1,n=function(t){return parseFloat(t)||0},a=function(e){var o=1,a=t(e),i=null,r=[];return a.each(function(){var e=t(this),a=e.offset().top-n(e.css("margin-top")),s=r.length>0?r[r.length-1]:null;null===s?r.push(e):Math.floor(Math.abs(i-a))<=o?r[r.length-1]=s.add(e):r.push(e),i=a}),r},i=function(e){var o={
byRow:!0,property:"height",target:null,remove:!1};return"object"==typeof e?t.extend(o,e):("boolean"==typeof e?o.byRow=e:"remove"===e&&(o.remove=!0),o)},r=t.fn.matchHeight=function(e){var o=i(e);if(o.remove){var n=this;return this.css(o.property,""),t.each(r._groups,function(t,e){e.elements=e.elements.not(n)}),this}return this.length<=1&&!o.target?this:(r._groups.push({elements:this,options:o}),r._apply(this,o),this)};r.version="0.7.2",r._groups=[],r._throttle=80,r._maintainScroll=!1,r._beforeUpdate=null,
r._afterUpdate=null,r._rows=a,r._parse=n,r._parseOptions=i,r._apply=function(e,o){var s=i(o),h=t(e),l=[h],c=t(window).scrollTop(),p=t("html").outerHeight(!0),u=h.parents().filter(":hidden");return u.each(function(){var e=t(this);e.data("style-cache",e.attr("style"))}),u.css("display","block"),s.byRow&&!s.target&&(h.each(function(){var e=t(this),o=e.css("display");"inline-block"!==o&&"flex"!==o&&"inline-flex"!==o&&(o="block"),e.data("style-cache",e.attr("style")),e.css({display:o,"padding-top":"0",
"padding-bottom":"0","margin-top":"0","margin-bottom":"0","border-top-width":"0","border-bottom-width":"0",height:"100px",overflow:"hidden"})}),l=a(h),h.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||"")})),t.each(l,function(e,o){var a=t(o),i=0;if(s.target)i=s.target.outerHeight(!1);else{if(s.byRow&&a.length<=1)return void a.css(s.property,"");a.each(function(){var e=t(this),o=e.attr("style"),n=e.css("display");"inline-block"!==n&&"flex"!==n&&"inline-flex"!==n&&(n="block");var a={
display:n};a[s.property]="",e.css(a),e.outerHeight(!1)>i&&(i=e.outerHeight(!1)),o?e.attr("style",o):e.css("display","")})}a.each(function(){var e=t(this),o=0;s.target&&e.is(s.target)||("border-box"!==e.css("box-sizing")&&(o+=n(e.css("border-top-width"))+n(e.css("border-bottom-width")),o+=n(e.css("padding-top"))+n(e.css("padding-bottom"))),e.css(s.property,i-o+"px"))})}),u.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||null)}),r._maintainScroll&&t(window).scrollTop(c/p*t("html").outerHeight(!0)),
this},r._applyDataApi=function(){var e={};t("[data-match-height], [data-mh]").each(function(){var o=t(this),n=o.attr("data-mh")||o.attr("data-match-height");n in e?e[n]=e[n].add(o):e[n]=o}),t.each(e,function(){this.matchHeight(!0)})};var s=function(e){r._beforeUpdate&&r._beforeUpdate(e,r._groups),t.each(r._groups,function(){r._apply(this.elements,this.options)}),r._afterUpdate&&r._afterUpdate(e,r._groups)};r._update=function(n,a){if(a&&"resize"===a.type){var i=t(window).width();if(i===e)return;e=i;
}n?o===-1&&(o=setTimeout(function(){s(a),o=-1},r._throttle)):s(a)},t(r._applyDataApi);var h=t.fn.on?"on":"bind";t(window)[h]("load",function(t){r._update(!1,t)}),t(window)[h]("resize orientationchange",function(t){r._update(!0,t)})});

$(document).ready(function() {

    const isHomePage = $('body.template-index').length > 0 ? true : false;
    const isCartPage = $('body.template-cart').length;
    const isProductPage = $('body.template-product').length;
    const isCollectionPage = $('body.template-collection').length;
    const isSearchPage = $('body.template-search').length;

    if (isHomePage) {
        if($('#our-range-slider').length > 0){
            initSliderWithSidebar('#our-range-slider');
        }
        if($('#latest-blogs-slider').length > 0){
            initSliderWithSidebar('#latest-blogs-slider');
        }
        
        $('.slider-with-sidebar-inner').removeClass('loading');
        
        $(window).resize($.debounce(250,function() {
            if($('#our-range-slider').length > 0){
                initSliderWithSidebar('#our-range-slider');
            }
            if($('#latest-blogs-slider').length > 0){
                initSliderWithSidebar('#latest-blogs-slider');
            }
            initTrendingSlider();
            titleColumnsButtonMobileSlider();
        }));
    }
    if (isCartPage) {
        initFreebie();
        checkForFreebie();
    }

    if (isProductPage) {
        $(document).arrive('[data-recommended-products] .spr-badge', function() {
            if ( $('.grid.product-single').hasClass('spr-ready') ) return;
            initProductRecommendations();
            updateSprBadge();
            $('.grid.product-single').addClass('spr-ready');
        });
        $('.pdp-readmore').on('click', function(e){
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top - $('[data-section-id="header"]').height()
            }, 500);      
        });
        // show sale badge on mobile gallery if product is on sale
        if ( $(window).width() < 992 && $('.product-is-on-sale').length !== 0 ) {
            $('.pdp-gallery-sale').show();
        }
        $(document).on('click', '.spr-badge-caption', function() {
            $('html, body').animate({
                scrollTop: $('.pdp-product-reviews-section').offset().top - $('[data-section-id="header"]').height()
            }, 500);     
        });
        if ($('.sale-percent').html()) {
            $('.pdp-gallery-sale').html($('.sale-percent').html()).addClass('sale-percent-mobile');
        }
        if ( $(window).width() < 992 && $('.product-is-on-sale').length !== 0 ) {
            
            $('.pdp-gallery-sale').show();
        }
        $('.MagicToolboxSelectorsContainer.no-magic-scroll a').first().click();
        // check if mobile thumbnails need to be scrollable
        $(window).on('resize', function() {
            if ( $(this).width() < 992 ) {
                const currentWindowWidth = $(this).width() - 30;
                let totalWidth = 0;
                $('.MagicToolboxSelectorsContainer.no-magic-scroll a').each(function(i, el) {
                    totalWidth += $(el).outerWidth() + 3;
                });
                if (totalWidth > currentWindowWidth) {
                    $('.MagicToolboxSelectorsContainer.no-magic-scroll a').first().addClass('force-margin');
                    $('.MagicToolboxSelectorsContainer.no-magic-scroll').scrollLeft(0);
                } else {
                    $('.MagicToolboxSelectorsContainer.no-magic-scroll a').first().removeClass('force-margin');
                }
            }
        });
        // add readonyl for quantity input on mobile
        $(window).on('resize', function() {
            if ( $(this).width() < 992 ) {
                $('.product-form__item--quantity input').attr('readonly', true);
            } else {
                $('.product-form__item--quantity input').removeAttr('readonly');
            }
        }).trigger('resize');
        if ( $('.hide-three-product-images').length ) {
            $('body').addClass('hide-expand-three-images');
        }
        getAverageReview();
        pdpFaqAccordion();
        pdpAfterPayTextEdit();
        bindQuantiyButtons();
    }

    if(isCollectionPage) {
        updateTickerStructure();
        plpReadMore();
    }
    if (isSearchPage) {
        updateSearchHeader();
    }

    // global functions
    showDesktopSearch();
    searchSuggestionUpdate();
    if ( $(window).width() < 993 ) {
        mobileSearchSuggestionUpdate();
    }
    

    
    function initSliderWithSidebar(parent) {
        let options = {
            cellAlign: 'left',
            contain: true,
            freeScroll: false,
            groupCells: '80%',
            pageDots: false,
            percentPosition: false
        };
        const $slider = $('.slider-with-sidebar', parent).flickity(options);
        const sliderData = $slider.data('flickity');
        const slides = sliderData.slides.length;
        const scrollBarContainerWidth = $('.nav-for-slider', parent).width();
        const partition = scrollBarContainerWidth / slides;
        const scrollBarwidth = $('.scrollbar', parent).width();
        const maxScrollBarX = scrollBarContainerWidth - scrollBarwidth;
        var scrollbarPositionX = 0;

        // If slider is moved, also move the slider scrollbar.
        $slider.on('scroll.flickity', function(event, progress) {
            
            // Calculate the x position. Make sure that the scrollbar won't go outside its scrollbar container.
            scrollbarPositionX = parseFloat((progress * maxScrollBarX).toFixed(2));
            if (scrollbarPositionX > maxScrollBarX) {
                scrollbarPositionX = maxScrollBarX;
            } else if (scrollbarPositionX < 0) {
                scrollbarPositionX = 0;
            }

            // Now move the scrollbar to x position.
            $('.scrollbar', parent).css({
                'transform': `translate(${scrollbarPositionX}px)`
            });
        });
        
        // Draggable scrollbar. 

        // https://github.com/taye/interact.js
        interact(parent + ' .scrollbar').draggable({
            lockAxis: 'x',
            inertia: true,
            modifiers: [
                interact.modifiers.restrictRect({
                    restriction: 'parent'
                })
            ],
            listeners: {
                move (event) {

                    // Calculate the x position. Make sure that the scrollbar won't go outside its scrollbar container.
                    
                    scrollbarPositionX += event.dx;
                    if (scrollbarPositionX > maxScrollBarX ) {
                        scrollbarPositionX = maxScrollBarX;
                    } else if (scrollbarPositionX < 0) {
                        scrollbarPositionX = 0;
                    }
                    event.target.style.transform = `translate(${scrollbarPositionX}px)`;

                    // Then calculate the x position of the slider.
                    const percentage = scrollbarPositionX / maxScrollBarX;
                    const slideX = percentage * -sliderData.slidesWidth;
                    sliderData.setTranslateX(slideX, false);
                },
            }
        }).styleCursor(false);

        // Ellipsis for blog excerpt.
        const $excerpt = $('.excerpt', parent);
        $('.excerpt', parent).each(function() {
            const $this = $(this);
            const allowedTextLines = 5;
            $this.ellipsis({ 
                lines: allowedTextLines - getTextLineCount($this.prev())
            });
        });

        // Count the number of text lines.
        function getTextLineCount($sliderTitle) {
            let fontSize = $sliderTitle.css('font-size');
            const divHeight = $sliderTitle.outerHeight();
            const lineHeight = fontSize.replace('px','') * 1.5;
            return Math.ceil(divHeight / lineHeight);
        }
    }
    function initFreebie() {
        if (!window.enable_free_gift) return;
        const freebieID = window.freebieVariantID ;
        const threshold = window.free_gift_over_price ;
        let prevItems;
        $('form.cart input[name="update"]').on('click', function(e) {
            e.preventDefault();
            const form = $(this).closest('form');
            // check if there is a freebie im the cart
            $.getJSON('/cart.js', function(cart) {
                prevItems = cart.items
                // const numberOfFreebie = prevItems.filter(item => item.id === freebieID ).length;
                const hasFreebie = prevItems.find(item => item.id === freebieID && item.line_price === 0);
                // submit the form normally
                if (!hasFreebie) {
                    $.ajax({
                        url: '/cart.js',
                        dataType: 'json',
                        cache: false,
                        type: 'post',
                        data: form.serialize(),
                        success: function success(product) {
                            window.location.href = '/cart';
                        }
                    });
                }
                $.ajax({
                    url: '/cart.js',
                    dataType: 'json',
                    cache: false,
                    type: 'post',
                    data: form.serialize(),
                    success: function success(product) {
                        if ((product.total_price - hasFreebie.original_price) > threshold) {
                            window.location.href = '/cart';
                        }
    
                        const items = product.items
                        // const currentNumberOfFreebie = items.filter(item => item.id === freebieID).length;
                       if (hasFreebie && (product.total_price - hasFreebie.original_price) < threshold & items.length > 1) {
                            const allFreebie = items.filter(item => item.id === freebieID && item.quantity === 1);
                            $.ajax({
                                type: 'POST',
                                url: '/cart/update.js',
                                data: {
                                    updates: {
                                        [freebieID]: 0
                                    }
                                },
                                dataType: 'json',
                                success: function() { 
                                    window.location.href = '/cart';
                                }
                            });
                        } else {
                            window.location.href = '/cart';
                        }
                    }
                });
            });
        });
    }
    /******************* PDP REcommendation slider *******************/
    function getAverageReview() {
        $(document).arrive('.pdp-product-reviews-section [type="application/ld+json"]', function() {
            const schema = JSON.parse( $(this).html() );
            const html = `<div class="pdp-average-rating">${schema.ratingValue.slice(0 ,3)}</div>`;
            $('.pdp-product-reviews-section .spr-header-title').after(html);
        });
        $(document).arrive('.pdp-product-reviews-section .spr-reviews', function() {
            if ( $(window).width() >= 1024 ) {
                $('.spr-review').each((i, el) => {
                    const author =  $(el).find('.spr-review-header-byline strong').first().text();
                    const contents = $(el).html();
                    const newContent = `
                        <div class="author-initial">${author.charAt(0)}</div>
                        <div class="review-contents">
                            ${contents}
                        </div>
                        `;
                    $(el).html(newContent);
                });
            }
        });

        $(document).on('click', '.pdp-product-reviews-section .spr-pagination a', function() {
                setTimeout(() => {
                if ( $(window).width() >= 1024 ) {
                        $('.spr-review').each((i, el) => {
                            const author =  $(el).find('.spr-review-header-byline strong').first().text();
                            const contents = $(el).html();
                            const newContent = `
                                <div class="author-initial">${author.charAt(0)}</div>
                                <div class="review-contents">
                                    ${contents}
                                </div>
                                `;
                            $(el).html(newContent);
                        });
                    }
        }, 1000)
        });
    }
    function initProductRecommendations() {
        let options = {
            cellAlign: 'center',
            pageDots: false,
            groupCells: false,
            initialIndex: 1,
            prevNextButtons: false
        };
        let maxHeight;
        $('[data-recommended-products] li').each(function() {
            maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
        });
        $('[data-recommended-products] li').each(function() {
            $(this).height(maxHeight);
        });

        $('[data-recommended-products]').flickity(options).flickity('resize');
        $(window).on('resize', function() {
            if ( $(this).width() < 991) {      
                $('[data-recommended-products]').flickity(options).flickity('resize');
            } else {
                if ( $('[data-recommended-products]').hasClass('flickity-enabled')) {
                    $('[data-recommended-products]').flickity('destroy');
                }
            }
        }).trigger('resize');
    }
    function pdpFaqAccordion() {
        $('.faq-accordion-header').on('click', function() {
            $('.faq-accordion-header').not(this).removeClass('active');
            $('.faq-accordion-content').not($(this).next()).slideUp(300);
            $(this).toggleClass('active');
            $(this).next('.faq-accordion-content').slideToggle(300);
        });
        // $('.pdp-product-description-accordion-header').on('click', function() {
        //     $(this).toggleClass('active');
        //     $(this).next('.pdp-product-description-accordion-content').slideToggle(300);
        // });
       if ($(window).width() < 992) {
            $('.pdp-product-description-accordion-header').on('click', function() {
                // console.log('hit');
                // Close all other accordions
                $('.pdp-product-description-accordion-header').not(this).removeClass('active');
                $('.pdp-product-description-accordion-content').not($(this).next()).slideUp(300);
            
                // Toggle the clicked accordion
                $(this).toggleClass('active');
                $(this).next('.pdp-product-description-accordion-content').slideToggle(300);
            });
        }else{
            $('.pdp-product-description-right .pdp-product-description-accordion-header').on('click', function() {
                // console.log('hit');
                // Close all other accordions
                $('.pdp-product-description-right .pdp-product-description-accordion-header').not(this).removeClass('active');
                $('.pdp-product-description-right .pdp-product-description-accordion-content').not($(this).next()).slideUp(300);
            
                // Toggle the clicked accordion
                $(this).toggleClass('active');
                $(this).next('.pdp-product-description-accordion-content').slideToggle(300);
            });
         
        }

            

        $('.pdp-desc-toggle').on('click', function() {
            const accordionHeader = $('.pdp-product-description-right .pdp-product-description-accordion-header');
            const accordionContent = $('.pdp-product-description-right .pdp-product-description-accordion-content');
            if ( $(this).hasClass('pdp-desc-toggle--open') ) {
                accordionHeader.addClass('active');
                accordionContent.slideDown(300);
                $(this).removeClass('pdp-desc-toggle--open').addClass('pdp-desc-toggle--close').text('Close All');
            } else {
                accordionHeader.removeClass('active');
                accordionContent.slideUp(300);
                $(this).removeClass('pdp-desc-toggle--close').addClass('pdp-desc-toggle--open').text('Expand All');
            }
        });
    }
    function pdpAfterPayTextEdit() {
        $(document).arrive('.product-information .afterpay-paragraph', function() {
            $('.afterpay-paragraph .afterpay-text1').html('4 payments of &nbsp;');
            $('.afterpay-paragraph .afterpay-text2').html('&nbsp;with&nbsp;');
        });
    }
    function bindQuantiyButtons() {
        const inputForm = $('.product-form__item--quantity input')
        $('.product-form__item--quantity .item-quantity-add').on('click', function() {
            const currentValue = parseInt(inputForm.val());
            const newValue = currentValue + 1;
            inputForm.val(newValue);
            bundlePriceUpdate(newValue + '');
        });
        
        $('.product-form__item--quantity .item-quantity-subtract').on('click', function() {
            const currentValue = parseInt(inputForm.val());
            if ( currentValue === 1 ) return;
            const newValue = currentValue - 1;
            inputForm.val(newValue);
            bundlePriceUpdate(newValue + '');
        });
    }
    function updateSprBadge() {
        const caption = $('.product-information .spr-badge-caption').text().replace(/[()]/g,'').trim();
        $('.product-information .spr-badge-caption').text(`${caption} Reviews`)
    }

    function formatPercentageString(percent) {
        return parseInt(percent.split('%')[0]) / 100;
    }

    function formatPromotionObject(promotions) {
        let newObj = {};
        Object.keys(promotions).map(promo => {
            if ( promo.indexOf('promo_quantity') !== -1 ) {
                const quantity = promotions[promo];
                const index = promo.split('promo_quantity_')[1];
                const currentSymbol = quantity + "_symbol";
                newObj = {
                    [quantity]: formatPercentageString( promotions['promotion_discount_' + index]),
                    [currentSymbol]: promotions['promotion_discount_' + index],
                    ...newObj
                }
            }
        });
        return newObj;
    }

    function findDiscount(itemQuantity, promotion) {
        // check for quantity plus discount
        const quantity = parseInt(itemQuantity);
        const plusDiscount = Object.keys(promotion).find(promo => promo.indexOf('+') !== -1);
        const noPlusDiscount = Object.keys(promotion).find(promo => promo === itemQuantity);
        let value;
        let noPlusDiscountValue;
        if (plusDiscount) {
            value = parseInt(plusDiscount.split('+')[0]);
        } else if (noPlusDiscount) {
            noPlusDiscountValue =  parseInt(noPlusDiscountValue);
        }
        if (plusDiscount && quantity >= value) {
            return [ promotion[plusDiscount], promotion[plusDiscount + "_symbol" ], value ];
        } else if (noPlusDiscount && quantity >= noPlusDiscountValue) {
            return [ promotion[plusDiscount], promotion[plusDiscount + "_symbol" ], noPlusDiscountValue ];
        } else {
            const quantityTier = Object.keys(promotion).find(promo => promo === itemQuantity);
            return [ promotion[itemQuantity], promotion[itemQuantity + "_symbol" ],  quantityTier];
        }
    }

    function bundlePriceUpdate(quantity) {
        const promotions = $('[data-pdp-promotions]').data('pdp-promotions');
        const currentPriceContainer = $('#ProductPrice-product-template');
        const productPrice = parseInt(currentPriceContainer.attr('data-product-price'));
        if ( $('[data-pdp-promotions]').length !== 0 )  {
            const formattedPromotion = formatPromotionObject(promotions);
            const priceContainer = $('.product-information .product-price__price');
            const bundledDiscountPrice = priceContainer.find('.bundled-price');
            if (quantity !== '1') {
                const [discount, percentageSymbol, quantityTier] = findDiscount(quantity, formattedPromotion);
                if (discount && parseInt(quantity) >= parseInt(quantityTier) ) {
                    const discountAmount = ( productPrice  * quantity ) - ( (productPrice  * quantity) * discount );
                    if (priceContainer.find('.bundled-price').length !== 0) {
                        bundledDiscountPrice.text(`$${discountAmount.toFixed(2)}`);
                    } else {
                        priceContainer.prepend(`<span class="bundled-price">$${discountAmount.toFixed(2)}</span>`);
                    }
                    // update current price multiply by the quantity
                    currentPriceContainer.text(`$${(productPrice * quantity).toFixed(2)}`);
                    $('.pdp-gallery-bundle-save').text(`SAVE ${percentageSymbol}`).show();
                } else {
                    $('.pdp-gallery-bundle-save').hide();
                    currentPriceContainer.text(`$${(productPrice * quantity).toFixed(2)}`);
                }
            } else {
                priceContainer.find('.bundled-price').remove();
                $('.pdp-gallery-bundle-save').hide();
                currentPriceContainer.text(`$${(productPrice).toFixed(2)}`);
            }
        }
        
    }

    function updateTickerStructure() {
        const maxTime = 500;
        let count = 0;
        function waitForEl( selector, callback ) {
            if( $(selector).length ){
                callback();
            } else {
                if(count <= maxTime){
                    setTimeout( function() {
                        waitForEl( selector, callback );
                    }, 100);
                    count++;
                }
            }
        }
        waitForEl('.counter-area .els-cup-w', function(){
            $('.els-cup-w-wrap > div').each(function(i, el){
                $(el).find('.els-cup-w-val, .els-cup-w-descr').wrapAll('<div class="els-cup-contents"></div>')
            });
            if ( $(window).width() < 768 ) {
                const icons = $('.els-cup-w-wrap').find('.els-cup-w-icon').remove();
                $('.els-cup-box').before(`<div class="mobile-bars-icon"></div>`);
                $('.mobile-bars-icon').html(icons);
            }
        });
        if ($('.els-cup-box').length && $(window).width() < 768 ) {
            $('.boost-pfs-filter-toolbar-count.mobile').insertAfter('.boost-pfs-filter-toolbar-sticky-mobile');
        }
    }

    // Cart page check free
    function checkForFreebie() {
        if (window.no_min_spend) {
            const freebieID = window.freebieVariantID;
            if ( $(`[data-item-variant-id="${freebieID}"]`).length && $(`[data-item-variant-id="${freebieID}"]`).data('item-variant-line-price') === 0 && $(`[data-item-variant-id="${freebieID}"]`).parent().find('.cart-item__discount').length ) {
                $(`[data-item-variant-id="${freebieID}"]`).parent().find('.saso-cart-item-line-price').hide();
            }
        }
    }
    
    /*function plpReadMore() {
        $('.boost-pfs-filter-collection-description div').ellipsis({
            lines: 3,             
            ellipClass: 'ellip'
        });
        if ($('.boost-pfs-filter-collection-description div').find('.plp-desc-readmore').length === 0) {
            $('.boost-pfs-filter-collection-description div').append('<a href="#" class="plp-desc-readmore">Read More</a>');
        }
        $(document).on('click', '.plp-desc-readmore', function(e) {
            e.preventDefault();
               //$('.boost-pfs-filter-collection-description div').find('.ellip-line').removeClass('ellip-line');
               $('.ellip-line').addClass('visible');
            $('.plp-desc-readmore').remove();
        });
    }*/

    function showDesktopSearch() {
        $('.site-header__search span').on('click', function(){
            $(this).closest('form').find('input').show().focus();
        });
    }
    function mobileSearchSuggestionUpdate() {
        let observer = new MutationObserver(function (mutations, me) {
            if ($('[data-search-box-id="boost-pfs-search-box-2"] > ul').css('display') !== 'none' && $('.boost-pfs-search-suggestion-item').length ) {
                $('[data-search-box-id="boost-pfs-search-box-2"] .boost-pfs-search-suggestion-group').not('[data-group="products"]').each(function() {
                    const currentGroup = $(this).attr('aria-label');
                    $(this).find('.boost-pfs-search-suggestion-item').each(function(){
                        if ($(this).find('span').length === 0 ) {
                            $(this).append(`<span>in ${  currentGroup.charAt(0).toUpperCase() + currentGroup.slice(1) }`);
                        }
                    });
                });
            }
        });
        // Start waiting for the element.
        observer.observe(document, {
            childList: true,
            subtree: true
        });
    }

    function searchSuggestionUpdate() {
        let observer = new MutationObserver(function (mutations, me) {
            if ( $('.boost-pfs-search-suggestion-item-product .boost-pfs-search-suggestion-product-title').length ) {
                $('.boost-pfs-search-suggestion-item-product .boost-pfs-search-suggestion-product-title').each(function(){
                    if ( $(this).text().length > 27 ) {
                        const trimmedText = $(this).text().substr(0, 22);
                        $(this).text(trimmedText + '...');
                    }
                });
            }
        });
        // Start waiting for the element.
        observer.observe(document, {
            childList: true,
            subtree: true
        });
        
    }

    function equalHeight() {
		var equal_i = -1;
		var equal_els = [];
		var equal_element = null;

		// Equal Height Title
		$('.boost-pfs-search-result-list-item').each(function(i, element) {

			var offsetTop = $(element).offset().top;
			if (!equal_element || equal_element.offset().top !== offsetTop) {
				equal_element = $(element);
				equal_i++;
			}

			if (!equal_els[equal_i]) {
				equal_els[equal_i] = [];
			}
			equal_els[equal_i].push(element);
		});

		for (var i = 0; i < equal_els.length; i++) {
			var max = 0;
			var maxRatio = 0;
			var iLength = equal_els[i].length;

			for (var j = 0; j < equal_els[i].length; j++) {
				var item = equal_els[i][j];
				var height = $(item).find('.boost-pfs-search-result-list-item-title').height();
				max = Math.max(max, height);
			
				$(item).find('.boost-pfs-search-result-list-item-title').addClass('height-'+height);
			}
			
			max += 5;

			$(equal_els[i]).find('.boost-pfs-search-result-list-item-title').css({ 'min-height': max });

		}
    }

    function updateSearchHeader() {
        let observer = new MutationObserver(function (mutations, me) {
            if ($('.boost-pfs-search-result-header').text().length ) {
                const urlString = window.location.href;
                const url = new URL(urlString);
                const q = url.searchParams.get("q");
                if (q) {
                    $('.boost-pfs-search-result-header').text(`Results for ${q}`);
                }
                if ( $(window).width() < 768) {
                    if ($('.boost-pfs-search-result-panel-controls li').length > 1) {
                        $('.boost-pfs-search-result-panel-controls button').on('click', function(){
                            const text = $(this).text().split(' ')[0];
                            if (text.length && text.toLowerCase() === 'blog') {
                                $('.boost-pfs-filter-toolbar-top-mobile.boost-pfs-filter-toolbar-sticky-mobile').hide();
                            } else {
                                $('.boost-pfs-filter-toolbar-top-mobile.boost-pfs-filter-toolbar-sticky-mobile').show();
                            }
                        });
                    }
                }
                equalHeight();
               me.disconnect();
            }
        });
        // Start waiting for the element.
        observer.observe(document, {
            childList: true,
            subtree: true
        });

        let observer2 = new MutationObserver(function (mutations, me) {
            if ( $('.boost-pfs-search-result-pages .boost-pfs-search-result-list-item').length ) {
                $('.boost-pfs-search-result-pages .boost-pfs-search-result-list-item').each(function(){
                    const url = $(this).find('a').attr('href');
                    if ( $(this).find('.blog-read-more').length === 0 && ($(this).find('.boost-pfs-search-result-list-item-summary').text().length || $(this).find('.boost-pfs-search-result-list-item-description').text().length) ) {
                        $(this).find('.boost-pfs-search-result-list-item-content').after(`<a class="blog-read-more" href="${url}">Read More</a>`);
                    }
                });
            }
        });
         // Start waiting for the element.
         observer2.observe(document, {
            childList: true,
            subtree: true
        });

        $(document).on('click', '.boost-pfs-search-result-panel-controls button', function() {
            if ( $(this).text().toLowerCase().indexOf('blog').length !== -1 ) {
                setTimeout(() => {
                    $('.boost-pfs-search-result-list-item-summary').ellipsis({
                        lines: 3,             
                        ellipClass: 'ellip'
                    });
                    $('.boost-pfs-search-result-list-item-description').ellipsis({
                        lines: 3,             
                        ellipClass: 'ellip'
                    });
                    $('.boost-pfs-search-result-list-item-content .boost-pfs-search-result-list-item-title').matchHeight({
                        byRow: true,
                        property: 'height'
                    })
                }, 500);
            }
        });
    }

});

theme.ProductRecommendations = (function() {
    function ProductRecommendations(container) {
      var $container = (this.$container = $(container));
      var baseUrl = $container.data('baseUrl');
      var productId = $container.data('productId');
      var limit = $container.data('limit');
      var productRecommendationsUrlAndContainerClass = baseUrl + '?section_id=product-recommendations&limit=' + limit +
        '&product_id=' +productId +
        ' .product-recommendations';
      $container.parent().load(productRecommendationsUrlAndContainerClass);
    }
    return ProductRecommendations;
  })();


//Ajax cart
if($('#theme-ajax-cart').length){
    Shopify.theme.jsAjaxCart.init($('#theme-ajax-cart'));
    Shopify.theme.quantityBox.init();
    
    if($('body').hasClass('template-cart')){
    Shopify.theme.jsCart.init($('#shopify-section-cart-template'));
    }
}
$(document).on('click', '.ajax-submit', function (e) {
    //e.preventDefault();
    var $addToCartForm = $(this).closest('form');
    Shopify.theme.jsAjaxCart.addToCart($addToCartForm);
    return false;
});

// $(document).ready(function() {
//  if($('body').hasClass('template-index') && !$('#MainContent').children(":first").hasClass("hero-banner")){
//     $('.hero-banner').css('padding-top', 0); 
//  }
// });



/////////////////////////// Theme Refresh Changes ///////////////////////////

$('body').on('click', 'a.mobile-search', function (event) {
    event.preventDefault();
    $('.boost-pfs-search-suggestion-mobile-top-panel, .boost-pfs-search-suggestion-mobile-overlay').show();
    $('.boost-pfs-search-suggestion-mobile-top-panel, input[name="q"]').focus();
});
$('body').on('change', '.so-accordion-wrapper input[type="checkbox"]', function (event) {
    $('.so-accordion-wrapper input[type="checkbox"]:checked').click();
});


// Function to check if the element is completely outside the viewport
    function isCompletelyOutsideViewport(element) {
        const rect = element[0].getBoundingClientRect();
        return rect.bottom < 0 || rect.top > (window.innerHeight || document.documentElement.clientHeight);
    }

    // Function to toggle the class on the body
    function toggleStickyButtonClass() {
        const $addButton = $('.product-form.product-form-product-template .product-form__item--submit');
        if ($addButton.length) {
            if (isCompletelyOutsideViewport($addButton)) {
                $('body').addClass('sticky-button--active');
                if($('.form-item--wrap button[name="add"]:visible')){
                  $('#sticky-btn').show();
                  $('#sticky-btn').next().hide();
                }else{
                  $('#sticky-btn').hide();
                  $('#sticky-btn').next().show();
                }
            } else {
                $('body').removeClass('sticky-button--active');
            }
        }
    }

    // Initial check on page load
    toggleStickyButtonClass();

    // Check on scroll
    $(window).on('scroll', function () {
        toggleStickyButtonClass();
    });

    // Optional: Check on window resize
    $(window).on('resize', function () {
        toggleStickyButtonClass();
    });
    $('body').on('click', '#sticky-btn', function (event) {
        $('.form-item--wrap button[name="add"]').click();
    });
    $('body').on('click', '.klaviyo-bis-trigger-custom', function (event) {
        document.querySelectorAll('a.btn.klaviyo-bis-trigger').forEach(function(element) {
              element.click();
          });
    });
    $('body').on('click', '.site-footer__linklist h4', function (event) {
        $('.site-footer__linklist h4.active').not(this).next().slideUp(''); 
        $('.site-footer__linklist h4.active').not(this).removeClass('active'); 
    });

console.log('hitttt????????????????');
window.addEventListener("load", function() {
  console.log('hitttt????????????????>>>>>>>');
  
  // Get the header section and calculate its height
  var headerSection = document.querySelector('[data-section-type="header-section"]');
  var headerHeight = headerSection ? headerSection.offsetHeight : 0;
  
  console.log('headerHeight =', headerHeight);
  
  // Set the custom property --search-top to the header height
  document.documentElement.style.setProperty('--search-top', headerHeight + 'px');
});

